/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import * as coreHttp from "@azure/core-http";


export const ApiVersionData: coreHttp.CompositeMapper = {
  serializedName: "ApiVersionData",
  type: {
    name: "Composite",
    className: "ApiVersionData",
    modelProperties: {
      versionNumber: {
        required: true,
        serializedName: "versionNumber",
        type: {
          name: "String"
        }
      },
      versionName: {
        required: true,
        serializedName: "versionName",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const AssociatedUser: coreHttp.CompositeMapper = {
  serializedName: "AssociatedUser",
  type: {
    name: "Composite",
    className: "AssociatedUser",
    modelProperties: {
      puid: {
        serializedName: "puid",
        type: {
          name: "String"
        }
      },
      firstName: {
        serializedName: "firstName",
        type: {
          name: "String"
        }
      },
      displayName: {
        serializedName: "displayName",
        type: {
          name: "String"
        }
      },
      email: {
        serializedName: "email",
        type: {
          name: "String"
        }
      },
      photoUrl: {
        serializedName: "photoUrl",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const AssociatedDevice: coreHttp.CompositeMapper = {
  serializedName: "AssociatedDevice",
  type: {
    name: "Composite",
    className: "AssociatedDevice",
    modelProperties: {
      deviceId: {
        serializedName: "deviceId",
        type: {
          name: "String"
        }
      },
      name: {
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      platform: {
        serializedName: "platform",
        type: {
          name: "Enum",
          allowedValues: [
            "Windows",
            "Android",
            "iOS",
            "macOS",
            "Unknown"
          ]
        }
      },
      type: {
        serializedName: "type",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "Desktop",
            "Laptop",
            "Tablet",
            "Mobile",
            "VirtualMachine"
          ]
        }
      },
      model: {
        serializedName: "model",
        type: {
          name: "String"
        }
      },
      osVersion: {
        serializedName: "osVersion",
        type: {
          name: "String"
        }
      },
      serialNumber: {
        serializedName: "serialNumber",
        type: {
          name: "String"
        }
      },
      lastReportedDateTime: {
        serializedName: "lastReportedDateTime",
        type: {
          name: "DateTime"
        }
      },
      associatedUsers: {
        serializedName: "associatedUsers",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AssociatedUser"
            }
          }
        }
      }
    }
  }
};

export const SingleBreachEntityField: coreHttp.CompositeMapper = {
  serializedName: "SingleBreachEntityField",
  type: {
    name: "Composite",
    className: "SingleBreachEntityField",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "String"
        }
      },
      createdDate: {
        serializedName: "createdDate",
        type: {
          name: "DateTime"
        }
      },
      entityId: {
        serializedName: "entityId",
        type: {
          name: "String"
        }
      },
      breachType: {
        serializedName: "breachType",
        type: {
          name: "Enum",
          allowedValues: [
            "SocialSecurityNumber",
            "EmailAddress",
            "MedicalId",
            "CreditCard",
            "CreditCardCVN",
            "BankAccountNumber",
            "DriverLicenseNumber",
            "PassportNumber",
            "NationalId",
            "InternationalBankAccountNumber",
            "RetailCardNumber",
            "BankRoute",
            "EbayPassword",
            "Password",
            "PhoneExt",
            "EbayUserId",
            "CardExpYear",
            "CreditCardPin",
            "BankingPin",
            "DriversLicenseState",
            "BankingPassword",
            "BankUserId",
            "DateOfBirth",
            "MothersMaidenName",
            "CellPhone",
            "WorkPhone",
            "HomePhone",
            "PaypalPassword",
            "UserId",
            "BankName",
            "CardExpDay",
            "LastName",
            "BankPhone",
            "Cardtype",
            "MiddleName",
            "Phone",
            "PaypalUserId",
            "CardExpDate",
            "CardExpMonth",
            "CardName",
            "FirstName",
            "CardAddr",
            "MedicalProvider",
            "PassportIssueDate",
            "PassportExpDate",
            "PassportCountry",
            "NationalCountry",
            "Address",
            "NotApplicable"
          ]
        }
      },
      state: {
        serializedName: "state",
        type: {
          name: "Enum",
          allowedValues: [
            "Remediated",
            "FalsePositive",
            "NotRelevant",
            "New"
          ]
        }
      },
      lastModifiedDate: {
        serializedName: "lastModifiedDate",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const Address: coreHttp.CompositeMapper = {
  serializedName: "Address",
  type: {
    name: "Composite",
    className: "Address",
    modelProperties: {
      addr1: {
        serializedName: "addr1",
        type: {
          name: "String"
        }
      },
      addr2: {
        serializedName: "addr2",
        type: {
          name: "String"
        }
      },
      addrCity: {
        serializedName: "addrCity",
        type: {
          name: "String"
        }
      },
      addrCountry: {
        serializedName: "addrCountry",
        type: {
          name: "String"
        }
      },
      addrstate: {
        serializedName: "addrstate",
        type: {
          name: "String"
        }
      },
      addrZip: {
        serializedName: "addrZip",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const CompositeBreachEntityField: coreHttp.CompositeMapper = {
  serializedName: "CompositeBreachEntityField",
  type: {
    name: "Composite",
    className: "CompositeBreachEntityField",
    modelProperties: {
      address: {
        serializedName: "address",
        type: {
          name: "Composite",
          className: "Address"
        }
      },
      entityId: {
        serializedName: "entityId",
        type: {
          name: "String"
        }
      },
      breachType: {
        serializedName: "breachType",
        type: {
          name: "Enum",
          allowedValues: [
            "SocialSecurityNumber",
            "EmailAddress",
            "MedicalId",
            "CreditCard",
            "CreditCardCVN",
            "BankAccountNumber",
            "DriverLicenseNumber",
            "PassportNumber",
            "NationalId",
            "InternationalBankAccountNumber",
            "RetailCardNumber",
            "BankRoute",
            "EbayPassword",
            "Password",
            "PhoneExt",
            "EbayUserId",
            "CardExpYear",
            "CreditCardPin",
            "BankingPin",
            "DriversLicenseState",
            "BankingPassword",
            "BankUserId",
            "DateOfBirth",
            "MothersMaidenName",
            "CellPhone",
            "WorkPhone",
            "HomePhone",
            "PaypalPassword",
            "UserId",
            "BankName",
            "CardExpDay",
            "LastName",
            "BankPhone",
            "Cardtype",
            "MiddleName",
            "Phone",
            "PaypalUserId",
            "CardExpDate",
            "CardExpMonth",
            "CardName",
            "FirstName",
            "CardAddr",
            "MedicalProvider",
            "PassportIssueDate",
            "PassportExpDate",
            "PassportCountry",
            "NationalCountry",
            "Address",
            "NotApplicable"
          ]
        }
      },
      state: {
        serializedName: "state",
        type: {
          name: "Enum",
          allowedValues: [
            "Remediated",
            "FalsePositive",
            "NotRelevant",
            "New"
          ]
        }
      },
      lastModifiedDate: {
        serializedName: "lastModifiedDate",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const IdentityMonitoringRecommendation: coreHttp.CompositeMapper = {
  serializedName: "IdentityMonitoringRecommendation",
  type: {
    name: "Composite",
    className: "IdentityMonitoringRecommendation",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      recommendationId: {
        serializedName: "recommendationId",
        type: {
          name: "Enum",
          allowedValues: [
            "EnableMFA",
            "ChangeSharedPasswords",
            "ContactRestorationServices",
            "ChangePassword",
            "CheckUnfamiliarTransactionsBank",
            "CheckUnfamiliarTransactionsCreditCard",
            "CheckUnfamiliarTransactionsEbay",
            "CheckUnfamiliarClaims",
            "ChangeSecurityQuestionsMothersName",
            "SelectNewPinBank",
            "RequestNewCard",
            "RequestNewCardRetailCard",
            "SelectNewPinCreditCard",
            "ChangeSecurityQuestionsBirthday",
            "ReviewCreditReports",
            "ReportStolenNationalId",
            "ReportStolenPassport",
            "CheckUnfamiliarTransactionsPayPal",
            "CheckUnfamiliarTransactionsRetail",
            "ReportIdTheft",
            "PlaceCreditFreeze",
            "UpdateAutomaticPayments",
            "ContactPhoneProvider",
            "DotNotCall",
            "EnableMFABank",
            "EnableMFABankPassword",
            "EnableMFAEbay",
            "EnableMFAPaypal",
            "ReviewCreditReportsAndContactRestorationServices",
            "ChangePasswordAndUsePasswordManager",
            "ChangeSharedPasswordsWithExplanation"
          ]
        }
      },
      breachEntityId: {
        serializedName: "breachEntityId",
        type: {
          name: "String"
        }
      },
      isCompleted: {
        serializedName: "isCompleted",
        type: {
          name: "Boolean"
        }
      },
      resolveDate: {
        serializedName: "resolveDate",
        type: {
          name: "DateTime"
        }
      },
      createdDate: {
        serializedName: "createdDate",
        type: {
          name: "DateTime"
        }
      },
      priority: {
        serializedName: "priority",
        type: {
          name: "Enum",
          allowedValues: [
            "NeedToBeDoneNow",
            "CanBeDoneLater"
          ]
        }
      }
    }
  }
};

export const BreachRecommendation: coreHttp.CompositeMapper = {
  serializedName: "BreachRecommendation",
  type: {
    name: "Composite",
    className: "BreachRecommendation",
    modelProperties: {
      recommendationId: {
        required: true,
        serializedName: "recommendationId",
        type: {
          name: "Enum",
          allowedValues: [
            "EnableMFA",
            "ChangeSharedPasswords",
            "ContactRestorationServices",
            "ChangePassword",
            "CheckUnfamiliarTransactionsBank",
            "CheckUnfamiliarTransactionsCreditCard",
            "CheckUnfamiliarTransactionsEbay",
            "CheckUnfamiliarClaims",
            "ChangeSecurityQuestionsMothersName",
            "SelectNewPinBank",
            "RequestNewCard",
            "RequestNewCardRetailCard",
            "SelectNewPinCreditCard",
            "ChangeSecurityQuestionsBirthday",
            "ReviewCreditReports",
            "ReportStolenNationalId",
            "ReportStolenPassport",
            "CheckUnfamiliarTransactionsPayPal",
            "CheckUnfamiliarTransactionsRetail",
            "ReportIdTheft",
            "PlaceCreditFreeze",
            "UpdateAutomaticPayments",
            "ContactPhoneProvider",
            "DotNotCall",
            "EnableMFABank",
            "EnableMFABankPassword",
            "EnableMFAEbay",
            "EnableMFAPaypal",
            "ReviewCreditReportsAndContactRestorationServices",
            "ChangePasswordAndUsePasswordManager",
            "ChangeSharedPasswordsWithExplanation"
          ]
        }
      },
      isCompleted: {
        required: true,
        serializedName: "isCompleted",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const BreachedDetail: coreHttp.CompositeMapper = {
  serializedName: "BreachedDetail",
  type: {
    name: "Composite",
    className: "BreachedDetail",
    modelProperties: {
      username: {
        serializedName: "username",
        type: {
          name: "String"
        }
      },
      breachId: {
        serializedName: "breachId",
        type: {
          name: "String"
        }
      },
      identityMonitoringBreachAlertId: {
        serializedName: "identityMonitoringBreachAlertId",
        type: {
          name: "String"
        }
      },
      alertIds: {
        serializedName: "alertIds",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      site: {
        serializedName: "site",
        type: {
          name: "String"
        }
      },
      siteFaviconUrl: {
        serializedName: "siteFaviconUrl",
        type: {
          name: "String"
        }
      },
      isKnownSite: {
        serializedName: "isKnownSite",
        type: {
          name: "Boolean"
        }
      },
      source: {
        serializedName: "source",
        type: {
          name: "Enum",
          allowedValues: [
            "ZyngaBreachSource",
            "DubsmashBreachSource",
            "CanvaBreachSource",
            "PdlBreachSource",
            "WattpadBreachSource",
            "VerificationsIOBreachSource",
            "EviteBreachSource",
            "AcxionBreachSource",
            "MyFitnessPalBreachSource",
            "TMobileBreachSource",
            "CovverBreachSource",
            "TeespringBreachSource",
            "NitroBreachSource",
            "TokopediaBreachSource",
            "PiZapBreachSource",
            "GomoAppsBreachSource",
            "HouzzBreachSource",
            "ShareThisBreachSource",
            "YouNowBreachSource",
            "ApolloBreachSource",
            "Unknown"
          ]
        }
      },
      changePasswordUrl: {
        serializedName: "changePasswordUrl",
        type: {
          name: "String"
        }
      },
      dateTimeOfBreach: {
        serializedName: "dateTimeOfBreach",
        type: {
          name: "DateTime"
        }
      },
      singleBreachEntities: {
        serializedName: "singleBreachEntities",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SingleBreachEntityField"
            }
          }
        }
      },
      compositeBreachEntities: {
        serializedName: "compositeBreachEntities",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CompositeBreachEntityField"
            }
          }
        }
      },
      recommendations: {
        serializedName: "recommendations",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "IdentityMonitoringRecommendation"
            }
          }
        }
      },
      breachRecommendations: {
        serializedName: "breachRecommendations",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BreachRecommendation"
            }
          }
        }
      },
      isActive: {
        required: true,
        serializedName: "isActive",
        type: {
          name: "Boolean"
        }
      },
      createdDateTime: {
        serializedName: "createdDateTime",
        type: {
          name: "DateTime"
        }
      },
      recommendationVersion: {
        serializedName: "recommendationVersion",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const BreachEntity: coreHttp.CompositeMapper = {
  serializedName: "BreachEntity",
  type: {
    name: "Composite",
    className: "BreachEntity",
    modelProperties: {
      entityId: {
        serializedName: "entityId",
        type: {
          name: "String"
        }
      },
      breachType: {
        serializedName: "breachType",
        type: {
          name: "Enum",
          allowedValues: [
            "SocialSecurityNumber",
            "EmailAddress",
            "MedicalId",
            "CreditCard",
            "CreditCardCVN",
            "BankAccountNumber",
            "DriverLicenseNumber",
            "PassportNumber",
            "NationalId",
            "InternationalBankAccountNumber",
            "RetailCardNumber",
            "BankRoute",
            "EbayPassword",
            "Password",
            "PhoneExt",
            "EbayUserId",
            "CardExpYear",
            "CreditCardPin",
            "BankingPin",
            "DriversLicenseState",
            "BankingPassword",
            "BankUserId",
            "DateOfBirth",
            "MothersMaidenName",
            "CellPhone",
            "WorkPhone",
            "HomePhone",
            "PaypalPassword",
            "UserId",
            "BankName",
            "CardExpDay",
            "LastName",
            "BankPhone",
            "Cardtype",
            "MiddleName",
            "Phone",
            "PaypalUserId",
            "CardExpDate",
            "CardExpMonth",
            "CardName",
            "FirstName",
            "CardAddr",
            "MedicalProvider",
            "PassportIssueDate",
            "PassportExpDate",
            "PassportCountry",
            "NationalCountry",
            "Address",
            "NotApplicable"
          ]
        }
      },
      state: {
        serializedName: "state",
        type: {
          name: "Enum",
          allowedValues: [
            "Remediated",
            "FalsePositive",
            "NotRelevant",
            "New"
          ]
        }
      },
      lastModifiedDate: {
        serializedName: "lastModifiedDate",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const BreachedDetailWithoutValues: coreHttp.CompositeMapper = {
  serializedName: "BreachedDetailWithoutValues",
  type: {
    name: "Composite",
    className: "BreachedDetailWithoutValues",
    modelProperties: {
      singleBreachEntities: {
        readOnly: true,
        serializedName: "singleBreachEntities",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BreachEntity"
            }
          }
        }
      },
      compositeBreachEntities: {
        readOnly: true,
        serializedName: "compositeBreachEntities",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BreachEntity"
            }
          }
        }
      },
      username: {
        serializedName: "username",
        type: {
          name: "String"
        }
      },
      breachId: {
        serializedName: "breachId",
        type: {
          name: "String"
        }
      },
      identityMonitoringBreachAlertId: {
        serializedName: "identityMonitoringBreachAlertId",
        type: {
          name: "String"
        }
      },
      alertIds: {
        serializedName: "alertIds",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      site: {
        serializedName: "site",
        type: {
          name: "String"
        }
      },
      siteFaviconUrl: {
        serializedName: "siteFaviconUrl",
        type: {
          name: "String"
        }
      },
      isKnownSite: {
        serializedName: "isKnownSite",
        type: {
          name: "Boolean"
        }
      },
      source: {
        serializedName: "source",
        type: {
          name: "Enum",
          allowedValues: [
            "ZyngaBreachSource",
            "DubsmashBreachSource",
            "CanvaBreachSource",
            "PdlBreachSource",
            "WattpadBreachSource",
            "VerificationsIOBreachSource",
            "EviteBreachSource",
            "AcxionBreachSource",
            "MyFitnessPalBreachSource",
            "TMobileBreachSource",
            "CovverBreachSource",
            "TeespringBreachSource",
            "NitroBreachSource",
            "TokopediaBreachSource",
            "PiZapBreachSource",
            "GomoAppsBreachSource",
            "HouzzBreachSource",
            "ShareThisBreachSource",
            "YouNowBreachSource",
            "ApolloBreachSource",
            "Unknown"
          ]
        }
      },
      changePasswordUrl: {
        serializedName: "changePasswordUrl",
        type: {
          name: "String"
        }
      },
      dateTimeOfBreach: {
        serializedName: "dateTimeOfBreach",
        type: {
          name: "DateTime"
        }
      },
      recommendations: {
        serializedName: "recommendations",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "IdentityMonitoringRecommendation"
            }
          }
        }
      },
      breachRecommendations: {
        serializedName: "breachRecommendations",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BreachRecommendation"
            }
          }
        }
      },
      isActive: {
        required: true,
        serializedName: "isActive",
        type: {
          name: "Boolean"
        }
      },
      createdDateTime: {
        serializedName: "createdDateTime",
        type: {
          name: "DateTime"
        }
      },
      recommendationVersion: {
        serializedName: "recommendationVersion",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const Pathsrtx3obapiV1MeCreditAlertsRecommendationsgetresponses200contenttextPlainschema: coreHttp.CompositeMapper = {
  serializedName: "paths·rtx3ob·api-v1-me-credit-alerts-recommendations·get·responses·200·content·text-plain·schema",
  type: {
    name: "Composite",
    className: "Pathsrtx3obapiV1MeCreditAlertsRecommendationsgetresponses200contenttextPlainschema",
    modelProperties: {
      creditBalanceDecrease: {
        serializedName: "CreditBalanceDecrease",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditBalanceIncrease: {
        serializedName: "CreditBalanceIncrease",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditUsageDecrease: {
        serializedName: "CreditUsageDecrease",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditUsageIncrease: {
        serializedName: "CreditUsageIncrease",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditLimitDecrease: {
        serializedName: "CreditLimitDecrease",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditLimitIncrease: {
        serializedName: "CreditLimitIncrease",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      dormantAccountActivityUnsecureLineOfCredit: {
        serializedName: "DormantAccountActivityUnsecureLineOfCredit",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      dormantAccountActivityBankCard: {
        serializedName: "DormantAccountActivityBankCard",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      dormantAccountActivityHomeEquity: {
        serializedName: "DormantAccountActivityHomeEquity",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      dormantAccountActivityRetailCard: {
        serializedName: "DormantAccountActivityRetailCard",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      newInquiry: {
        serializedName: "NewInquiry",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      newAddress: {
        serializedName: "NewAddress",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      accountClosed: {
        serializedName: "AccountClosed",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      accountCurrent: {
        serializedName: "AccountCurrent",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      accountImproved: {
        serializedName: "AccountImproved",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      accountPaid: {
        serializedName: "AccountPaid",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      cardOverLimit: {
        serializedName: "CardOverLimit",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      deceased: {
        serializedName: "Deceased",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      lostOrStolenCard: {
        serializedName: "LostOrStolenCard",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      majorDerogatory: {
        serializedName: "MajorDerogatory",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      delinquent: {
        serializedName: "Delinquent",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      settlement: {
        serializedName: "Settlement",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      skipCannotLocate: {
        serializedName: "SkipCannotLocate",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      tradelineBankruptcy: {
        serializedName: "TradelineBankruptcy",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditFileLocked: {
        serializedName: "CreditFileLocked",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditFileUnlocked: {
        serializedName: "CreditFileUnlocked",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditFileUnlockedDueToMembershipChange: {
        serializedName: "CreditFileUnlockedDueToMembershipChange",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      inquiryBlocked: {
        serializedName: "InquiryBlocked",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      identityValidation: {
        serializedName: "IdentityValidation",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      newApplication: {
        serializedName: "NewApplication",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      publicRecordLiensAndJudgements: {
        serializedName: "PublicRecordLiensAndJudgements",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      publicRecordBankruptcy: {
        serializedName: "PublicRecordBankruptcy",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      publicRecordSettlement: {
        serializedName: "PublicRecordSettlement",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      newAccountNewTrade: {
        serializedName: "NewAccountNewTrade",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      sSNTrace: {
        serializedName: "SSNTrace",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      unknown: {
        serializedName: "Unknown",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      notApplicable: {
        serializedName: "NotApplicable",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      }
    }
  }
};

export const Paths15vstsmapiV1MeCreditAlertsRecommendationsgetresponses200contentapplicationJsonschema: coreHttp.CompositeMapper = {
  serializedName: "paths·15vstsm·api-v1-me-credit-alerts-recommendations·get·responses·200·content·application-json·schema",
  type: {
    name: "Composite",
    className: "Paths15vstsmapiV1MeCreditAlertsRecommendationsgetresponses200contentapplicationJsonschema",
    modelProperties: {
      creditBalanceDecrease: {
        serializedName: "CreditBalanceDecrease",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditBalanceIncrease: {
        serializedName: "CreditBalanceIncrease",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditUsageDecrease: {
        serializedName: "CreditUsageDecrease",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditUsageIncrease: {
        serializedName: "CreditUsageIncrease",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditLimitDecrease: {
        serializedName: "CreditLimitDecrease",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditLimitIncrease: {
        serializedName: "CreditLimitIncrease",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      dormantAccountActivityUnsecureLineOfCredit: {
        serializedName: "DormantAccountActivityUnsecureLineOfCredit",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      dormantAccountActivityBankCard: {
        serializedName: "DormantAccountActivityBankCard",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      dormantAccountActivityHomeEquity: {
        serializedName: "DormantAccountActivityHomeEquity",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      dormantAccountActivityRetailCard: {
        serializedName: "DormantAccountActivityRetailCard",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      newInquiry: {
        serializedName: "NewInquiry",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      newAddress: {
        serializedName: "NewAddress",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      accountClosed: {
        serializedName: "AccountClosed",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      accountCurrent: {
        serializedName: "AccountCurrent",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      accountImproved: {
        serializedName: "AccountImproved",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      accountPaid: {
        serializedName: "AccountPaid",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      cardOverLimit: {
        serializedName: "CardOverLimit",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      deceased: {
        serializedName: "Deceased",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      lostOrStolenCard: {
        serializedName: "LostOrStolenCard",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      majorDerogatory: {
        serializedName: "MajorDerogatory",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      delinquent: {
        serializedName: "Delinquent",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      settlement: {
        serializedName: "Settlement",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      skipCannotLocate: {
        serializedName: "SkipCannotLocate",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      tradelineBankruptcy: {
        serializedName: "TradelineBankruptcy",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditFileLocked: {
        serializedName: "CreditFileLocked",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditFileUnlocked: {
        serializedName: "CreditFileUnlocked",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditFileUnlockedDueToMembershipChange: {
        serializedName: "CreditFileUnlockedDueToMembershipChange",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      inquiryBlocked: {
        serializedName: "InquiryBlocked",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      identityValidation: {
        serializedName: "IdentityValidation",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      newApplication: {
        serializedName: "NewApplication",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      publicRecordLiensAndJudgements: {
        serializedName: "PublicRecordLiensAndJudgements",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      publicRecordBankruptcy: {
        serializedName: "PublicRecordBankruptcy",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      publicRecordSettlement: {
        serializedName: "PublicRecordSettlement",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      newAccountNewTrade: {
        serializedName: "NewAccountNewTrade",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      sSNTrace: {
        serializedName: "SSNTrace",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      unknown: {
        serializedName: "Unknown",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      notApplicable: {
        serializedName: "NotApplicable",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      }
    }
  }
};

export const Paths10i8zh9apiV1MeCreditAlertsRecommendationsgetresponses200contenttextJsonschema: coreHttp.CompositeMapper = {
  serializedName: "paths·10i8zh9·api-v1-me-credit-alerts-recommendations·get·responses·200·content·text-json·schema",
  type: {
    name: "Composite",
    className: "Paths10i8zh9apiV1MeCreditAlertsRecommendationsgetresponses200contenttextJsonschema",
    modelProperties: {
      creditBalanceDecrease: {
        serializedName: "CreditBalanceDecrease",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditBalanceIncrease: {
        serializedName: "CreditBalanceIncrease",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditUsageDecrease: {
        serializedName: "CreditUsageDecrease",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditUsageIncrease: {
        serializedName: "CreditUsageIncrease",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditLimitDecrease: {
        serializedName: "CreditLimitDecrease",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditLimitIncrease: {
        serializedName: "CreditLimitIncrease",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      dormantAccountActivityUnsecureLineOfCredit: {
        serializedName: "DormantAccountActivityUnsecureLineOfCredit",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      dormantAccountActivityBankCard: {
        serializedName: "DormantAccountActivityBankCard",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      dormantAccountActivityHomeEquity: {
        serializedName: "DormantAccountActivityHomeEquity",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      dormantAccountActivityRetailCard: {
        serializedName: "DormantAccountActivityRetailCard",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      newInquiry: {
        serializedName: "NewInquiry",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      newAddress: {
        serializedName: "NewAddress",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      accountClosed: {
        serializedName: "AccountClosed",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      accountCurrent: {
        serializedName: "AccountCurrent",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      accountImproved: {
        serializedName: "AccountImproved",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      accountPaid: {
        serializedName: "AccountPaid",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      cardOverLimit: {
        serializedName: "CardOverLimit",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      deceased: {
        serializedName: "Deceased",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      lostOrStolenCard: {
        serializedName: "LostOrStolenCard",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      majorDerogatory: {
        serializedName: "MajorDerogatory",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      delinquent: {
        serializedName: "Delinquent",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      settlement: {
        serializedName: "Settlement",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      skipCannotLocate: {
        serializedName: "SkipCannotLocate",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      tradelineBankruptcy: {
        serializedName: "TradelineBankruptcy",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditFileLocked: {
        serializedName: "CreditFileLocked",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditFileUnlocked: {
        serializedName: "CreditFileUnlocked",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      creditFileUnlockedDueToMembershipChange: {
        serializedName: "CreditFileUnlockedDueToMembershipChange",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      inquiryBlocked: {
        serializedName: "InquiryBlocked",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      identityValidation: {
        serializedName: "IdentityValidation",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      newApplication: {
        serializedName: "NewApplication",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      publicRecordLiensAndJudgements: {
        serializedName: "PublicRecordLiensAndJudgements",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      publicRecordBankruptcy: {
        serializedName: "PublicRecordBankruptcy",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      publicRecordSettlement: {
        serializedName: "PublicRecordSettlement",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      newAccountNewTrade: {
        serializedName: "NewAccountNewTrade",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      sSNTrace: {
        serializedName: "SSNTrace",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      unknown: {
        serializedName: "Unknown",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      },
      notApplicable: {
        serializedName: "NotApplicable",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      }
    }
  }
};

export const ProtectionSetting: coreHttp.CompositeMapper = {
  serializedName: "ProtectionSetting",
  type: {
    name: "Composite",
    className: "ProtectionSetting",
    modelProperties: {
      state: {
        serializedName: "state",
        type: {
          name: "Enum",
          allowedValues: [
            "NotApplicable",
            "On",
            "Off"
          ]
        }
      },
      isManagedByAdministrator: {
        serializedName: "isManagedByAdministrator",
        type: {
          name: "Boolean"
        }
      },
      lastModifiedDateTime: {
        serializedName: "lastModifiedDateTime",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const UnsafeUrl: coreHttp.CompositeMapper = {
  serializedName: "UnsafeUrl",
  type: {
    name: "Composite",
    className: "UnsafeUrl",
    modelProperties: {
      url: {
        serializedName: "url",
        type: {
          name: "String"
        }
      },
      category: {
        required: true,
        serializedName: "category",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "Phishing",
            "Malware",
            "Exploit",
            "Malvertising",
            "Untrusted",
            "Malicious",
            "TechScam",
            "CustomPolicy"
          ]
        }
      },
      userAction: {
        required: true,
        serializedName: "userAction",
        type: {
          name: "Enum",
          allowedValues: [
            "None",
            "Blocked",
            "Bypassed"
          ]
        }
      },
      dateDetected: {
        serializedName: "dateDetected",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const DeviceHealthStatus: coreHttp.CompositeMapper = {
  serializedName: "DeviceHealthStatus",
  type: {
    name: "Composite",
    className: "DeviceHealthStatus",
    modelProperties: {
      state: {
        serializedName: "state",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "Protected",
            "NeedsAttention",
            "ActionRecommended",
            "NotFullyProtected"
          ]
        }
      },
      severity: {
        serializedName: "severity",
        type: {
          name: "Enum",
          allowedValues: [
            "Grey",
            "Green",
            "Yellow",
            "Red"
          ]
        }
      }
    }
  }
};

export const DismissableProtectionSetting: coreHttp.CompositeMapper = {
  serializedName: "DismissableProtectionSetting",
  type: {
    name: "Composite",
    className: "DismissableProtectionSetting",
    modelProperties: {
      isDismissed: {
        serializedName: "isDismissed",
        type: {
          name: "Boolean"
        }
      },
      state: {
        serializedName: "state",
        type: {
          name: "Enum",
          allowedValues: [
            "NotApplicable",
            "On",
            "Off"
          ]
        }
      },
      isManagedByAdministrator: {
        serializedName: "isManagedByAdministrator",
        type: {
          name: "Boolean"
        }
      },
      lastModifiedDateTime: {
        serializedName: "lastModifiedDateTime",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const DefenderProtectionUpdates: coreHttp.CompositeMapper = {
  serializedName: "DefenderProtectionUpdates",
  type: {
    name: "Composite",
    className: "DefenderProtectionUpdates",
    modelProperties: {
      lastUpdatedDateTime: {
        serializedName: "lastUpdatedDateTime",
        type: {
          name: "DateTime"
        }
      },
      currentVersion: {
        serializedName: "currentVersion",
        type: {
          name: "String"
        }
      },
      isUpToDate: {
        serializedName: "isUpToDate",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const Threat: coreHttp.CompositeMapper = {
  serializedName: "Threat",
  type: {
    name: "Composite",
    className: "Threat",
    modelProperties: {
      detectionId: {
        required: true,
        serializedName: "detectionId",
        type: {
          name: "String"
        }
      },
      threatId: {
        serializedName: "threatId",
        type: {
          name: "String"
        }
      },
      type: {
        required: true,
        serializedName: "type",
        type: {
          name: "Enum",
          allowedValues: [
            "App",
            "File"
          ]
        }
      },
      name: {
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      infectedPackageName: {
        serializedName: "infectedPackageName",
        type: {
          name: "String"
        }
      },
      appName: {
        serializedName: "appName",
        type: {
          name: "String"
        }
      },
      category: {
        required: true,
        serializedName: "category",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "Adware",
            "AolExploiter",
            "ArchiveBomb",
            "Backdoor",
            "Behavior",
            "BrowserModifier",
            "BrowserPlugin",
            "Cookie",
            "Dialer",
            "EmailFlooder",
            "Exploit",
            "FileSharingProgram",
            "HipsRule",
            "HostileActiveXControl",
            "IcqExploit",
            "JokeProgram",
            "KeyLogger",
            "Known",
            "Malware",
            "MalwareCreationTool",
            "MonitoringSoftware",
            "Nuker",
            "PasswordStealer",
            "Policy",
            "PotentiallyUnwantedSoftware",
            "Ransomware",
            "RemoteAccessTrojan",
            "RemoteControlSoftware",
            "SSP",
            "SecurityDisabler",
            "SettingsModifier",
            "SoftwareBundler",
            "Spyware",
            "StealthNotifier",
            "Toolbar",
            "Trojan",
            "TrojanDenialOfService",
            "TrojanDownloader",
            "TrojanDropper",
            "TrojanFtp",
            "TrojanMassMailer",
            "TrojanMonitoringSoftware",
            "TrojanProxyServer",
            "TrojanTelnet",
            "Virus",
            "Vulnerability",
            "Worm"
          ]
        }
      },
      severity: {
        required: true,
        serializedName: "severity",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "Low",
            "Moderate",
            "High",
            "Severe"
          ]
        }
      },
      status: {
        required: true,
        serializedName: "status",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "Abandoned",
            "AllowFailed",
            "Allowed",
            "BlockFailed",
            "Blocked",
            "CleanFailed",
            "Cleaned",
            "Detected",
            "Quarantined",
            "RemoveFailed",
            "Removed",
            "RemovedFromQuarantine",
            "RestoredFromQuarantine"
          ]
        }
      },
      dateDetected: {
        required: true,
        serializedName: "dateDetected",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const ScanResults: coreHttp.CompositeMapper = {
  serializedName: "ScanResults",
  type: {
    name: "Composite",
    className: "ScanResults",
    modelProperties: {
      scanDateTime: {
        serializedName: "scanDateTime",
        type: {
          name: "DateTime"
        }
      },
      scanType: {
        required: true,
        serializedName: "scanType",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "Quick",
            "Full",
            "Custom",
            "Offline"
          ]
        }
      },
      scanMode: {
        required: true,
        serializedName: "scanMode",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "Auto",
            "Manual",
            "Live",
            "OnMount"
          ]
        }
      },
      scanDurationInSeconds: {
        serializedName: "scanDurationInSeconds",
        type: {
          name: "Number"
        }
      },
      filesScanned: {
        serializedName: "filesScanned",
        type: {
          name: "Number"
        }
      },
      appsScanned: {
        serializedName: "appsScanned",
        type: {
          name: "Number"
        }
      },
      threatsFound: {
        serializedName: "threatsFound",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Threat"
            }
          }
        }
      }
    }
  }
};

export const ThirdPartyAvSettings: coreHttp.CompositeMapper = {
  serializedName: "ThirdPartyAvSettings",
  type: {
    name: "Composite",
    className: "ThirdPartyAvSettings",
    modelProperties: {
      isEnabled: {
        required: true,
        serializedName: "isEnabled",
        type: {
          name: "Boolean"
        }
      },
      antivirusName: {
        serializedName: "antivirusName",
        type: {
          name: "String"
        }
      },
      defenderMode: {
        required: true,
        serializedName: "defenderMode",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "Passive",
            "SideBySide",
            "Normal",
            "PassiveAudit",
            "EdrBlock",
            "NotRunning"
          ]
        }
      },
      lastModifiedDateTime: {
        serializedName: "lastModifiedDateTime",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const DeviceProtectionStatus: coreHttp.CompositeMapper = {
  serializedName: "DeviceProtectionStatus",
  type: {
    name: "Composite",
    className: "DeviceProtectionStatus",
    modelProperties: {
      screenLockSetting: {
        serializedName: "screenLockSetting",
        type: {
          name: "Composite",
          className: "ProtectionSetting"
        }
      },
      isRequiredSetupCompleted: {
        serializedName: "isRequiredSetupCompleted",
        type: {
          name: "Enum",
          allowedValues: [
            "NotApplicable",
            "True",
            "False"
          ]
        }
      },
      missingPermissions: {
        serializedName: "missingPermissions",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      unsafeUrls: {
        serializedName: "unsafeUrls",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "UnsafeUrl"
            }
          }
        }
      },
      hasManuallyOpenedApp: {
        serializedName: "hasManuallyOpenedApp",
        type: {
          name: "Boolean"
        }
      },
      healthStatus: {
        serializedName: "healthStatus",
        type: {
          name: "Composite",
          className: "DeviceHealthStatus"
        }
      },
      realTimeProtectionSetting: {
        serializedName: "realTimeProtectionSetting",
        type: {
          name: "Composite",
          className: "ProtectionSetting"
        }
      },
      antiPhishingSetting: {
        serializedName: "antiPhishingSetting",
        type: {
          name: "Composite",
          className: "ProtectionSetting"
        }
      },
      advancedThreatProtectionSetting: {
        serializedName: "advancedThreatProtectionSetting",
        type: {
          name: "Composite",
          className: "ProtectionSetting"
        }
      },
      autoSampleSubmissionSetting: {
        serializedName: "autoSampleSubmissionSetting",
        type: {
          name: "Composite",
          className: "DismissableProtectionSetting"
        }
      },
      autoScanSetting: {
        serializedName: "autoScanSetting",
        type: {
          name: "Composite",
          className: "ProtectionSetting"
        }
      },
      vpnSetting: {
        serializedName: "vpnSetting",
        type: {
          name: "Composite",
          className: "ProtectionSetting"
        }
      },
      saferWifiSetting: {
        serializedName: "saferWifiSetting",
        type: {
          name: "Composite",
          className: "ProtectionSetting"
        }
      },
      cloudDeliveredProtectionSetting: {
        serializedName: "cloudDeliveredProtectionSetting",
        type: {
          name: "Composite",
          className: "ProtectionSetting"
        }
      },
      tamperProtectionSetting: {
        serializedName: "tamperProtectionSetting",
        type: {
          name: "Composite",
          className: "ProtectionSetting"
        }
      },
      defenderProtectionUpdates: {
        serializedName: "defenderProtectionUpdates",
        type: {
          name: "Composite",
          className: "DefenderProtectionUpdates"
        }
      },
      isJailBroken: {
        serializedName: "isJailBroken",
        type: {
          name: "Enum",
          allowedValues: [
            "NotApplicable",
            "True",
            "False"
          ]
        }
      },
      lastScanResults: {
        serializedName: "lastScanResults",
        type: {
          name: "Composite",
          className: "ScanResults"
        }
      },
      activeThreats: {
        serializedName: "activeThreats",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Threat"
            }
          }
        }
      },
      thirdPartyAvSettings: {
        serializedName: "thirdPartyAvSettings",
        type: {
          name: "Composite",
          className: "ThirdPartyAvSettings"
        }
      },
      lastReportedDateTime: {
        serializedName: "lastReportedDateTime",
        type: {
          name: "DateTime"
        }
      },
      isVpnSupported: {
        serializedName: "isVpnSupported",
        type: {
          name: "Boolean"
        }
      },
      isConsumerVpnSupported: {
        serializedName: "isConsumerVpnSupported",
        type: {
          name: "Boolean"
        }
      },
      isSaferWifiSupported: {
        serializedName: "isSaferWifiSupported",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const DeviceProtectionActivity: coreHttp.CompositeMapper = {
  serializedName: "DeviceProtectionActivity",
  type: {
    name: "Composite",
    className: "DeviceProtectionActivity",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      deviceId: {
        required: true,
        serializedName: "deviceId",
        type: {
          name: "String"
        }
      },
      deviceProtectionStatus: {
        serializedName: "deviceProtectionStatus",
        type: {
          name: "Composite",
          className: "DeviceProtectionStatus"
        }
      },
      activityDateTime: {
        serializedName: "activityDateTime",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const Device: coreHttp.CompositeMapper = {
  serializedName: "Device",
  type: {
    name: "Composite",
    className: "Device",
    modelProperties: {
      isDeleted: {
        serializedName: "isDeleted",
        type: {
          name: "Boolean"
        }
      },
      lastReportedDateTime: {
        serializedName: "lastReportedDateTime",
        type: {
          name: "DateTime"
        }
      },
      lastModifiedDateTime: {
        serializedName: "lastModifiedDateTime",
        type: {
          name: "DateTime"
        }
      },
      expirationDateTime: {
        serializedName: "expirationDateTime",
        type: {
          name: "DateTime"
        }
      },
      deviceId: {
        serializedName: "deviceId",
        type: {
          name: "String"
        }
      },
      name: {
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      nickname: {
        serializedName: "nickname",
        type: {
          name: "String"
        }
      },
      type: {
        serializedName: "type",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "Desktop",
            "Laptop",
            "Tablet",
            "Mobile",
            "VirtualMachine"
          ]
        }
      },
      model: {
        serializedName: "model",
        type: {
          name: "String"
        }
      },
      platform: {
        serializedName: "platform",
        type: {
          name: "Enum",
          allowedValues: [
            "Windows",
            "Android",
            "iOS",
            "macOS",
            "Unknown"
          ]
        }
      },
      onboardingStatus: {
        serializedName: "onboardingStatus",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "InProgress",
            "Postponed",
            "Completed"
          ]
        }
      },
      osVersion: {
        serializedName: "osVersion",
        type: {
          name: "String"
        }
      },
      serialNumber: {
        serializedName: "serialNumber",
        type: {
          name: "String"
        }
      },
      loginMethod: {
        serializedName: "loginMethod",
        type: {
          name: "String"
        }
      },
      protectionStatus: {
        serializedName: "protectionStatus",
        type: {
          name: "Composite",
          className: "DeviceProtectionStatus"
        }
      }
    }
  }
};

export const FamilyInvitation: coreHttp.CompositeMapper = {
  serializedName: "FamilyInvitation",
  type: {
    name: "Composite",
    className: "FamilyInvitation",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      role: {
        required: true,
        serializedName: "role",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "Admin",
            "User"
          ]
        }
      },
      invitedDateTime: {
        serializedName: "invitedDateTime",
        type: {
          name: "DateTime"
        }
      },
      expiryDateTime: {
        serializedName: "expiryDateTime",
        type: {
          name: "DateTime"
        }
      },
      email: {
        serializedName: "email",
        type: {
          name: "String"
        }
      },
      phone: {
        serializedName: "phone",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const FamilyMember: coreHttp.CompositeMapper = {
  serializedName: "FamilyMember",
  type: {
    name: "Composite",
    className: "FamilyMember",
    modelProperties: {
      puid: {
        serializedName: "puid",
        type: {
          name: "String"
        }
      },
      cid: {
        serializedName: "cid",
        type: {
          name: "String"
        }
      },
      displayName: {
        serializedName: "displayName",
        type: {
          name: "String"
        }
      },
      firstName: {
        serializedName: "firstName",
        type: {
          name: "String"
        }
      },
      lastName: {
        serializedName: "lastName",
        type: {
          name: "String"
        }
      },
      userPrincipalName: {
        serializedName: "userPrincipalName",
        type: {
          name: "String"
        }
      },
      role: {
        required: true,
        serializedName: "role",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "Admin",
            "User"
          ]
        }
      },
      joinedDate: {
        serializedName: "joinedDate",
        type: {
          name: "DateTime"
        }
      },
      photoUrl: {
        serializedName: "photoUrl",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const ITPFamilyPermissions: coreHttp.CompositeMapper = {
  serializedName: "ITPFamilyPermissions",
  type: {
    name: "Composite",
    className: "ITPFamilyPermissions",
    modelProperties: {
      canToggle: {
        serializedName: "canToggle",
        type: {
          name: "Boolean"
        }
      },
      lastModified: {
        serializedName: "lastModified",
        type: {
          name: "DateTime"
        }
      },
      value: {
        serializedName: "value",
        type: {
          name: "Enum",
          allowedValues: [
            "SEE_MY_ALERTS_AND_ADD_INFO",
            "ADD_MY_INFO",
            "NONE"
          ]
        }
      }
    }
  }
};

export const UserInfo: coreHttp.CompositeMapper = {
  serializedName: "UserInfo",
  type: {
    name: "Composite",
    className: "UserInfo",
    modelProperties: {
      userId: {
        serializedName: "userId",
        type: {
          name: "String"
        }
      },
      firstName: {
        serializedName: "firstName",
        type: {
          name: "String"
        }
      },
      lastName: {
        serializedName: "lastName",
        type: {
          name: "String"
        }
      },
      displayName: {
        serializedName: "displayName",
        type: {
          name: "String"
        }
      },
      email: {
        serializedName: "email",
        type: {
          name: "String"
        }
      },
      photoUrl: {
        serializedName: "photoUrl",
        type: {
          name: "String"
        }
      },
      isCurrentUser: {
        serializedName: "isCurrentUser",
        type: {
          name: "Boolean"
        }
      },
      isAdult: {
        serializedName: "isAdult",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const UserItpSummary: coreHttp.CompositeMapper = {
  serializedName: "UserItpSummary",
  type: {
    name: "Composite",
    className: "UserItpSummary",
    modelProperties: {
      name: {
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      email: {
        serializedName: "email",
        type: {
          name: "String"
        }
      },
      userId: {
        serializedName: "userId",
        type: {
          name: "String"
        }
      },
      csid: {
        serializedName: "csid",
        type: {
          name: "String"
        }
      },
      itPOnboarded: {
        serializedName: "itP_Onboarded",
        type: {
          name: "Boolean"
        }
      },
      itmOnboarded: {
        serializedName: "itmOnboarded",
        type: {
          name: "Boolean"
        }
      },
      cmOnboarded: {
        serializedName: "cmOnboarded",
        type: {
          name: "Boolean"
        }
      },
      itpOnboardingStatus: {
        serializedName: "itpOnboardingStatus",
        type: {
          name: "Enum",
          allowedValues: [
            "Unmonitored",
            "StatusNotShared",
            "Monitoring"
          ]
        }
      },
      cmOnboardingStatus: {
        serializedName: "cmOnboardingStatus",
        type: {
          name: "Enum",
          allowedValues: [
            "Unmonitored",
            "StatusNotShared",
            "Monitoring",
            "NotAvailable"
          ]
        }
      },
      ssnValidationStatus: {
        serializedName: "ssnValidationStatus",
        type: {
          name: "Enum",
          allowedValues: [
            "NotAvailable",
            "NotStarted",
            "SSNFailed",
            "SSNRegistered"
          ]
        }
      },
      itpFamilyPermissions: {
        serializedName: "itpFamilyPermissions",
        type: {
          name: "Composite",
          className: "ITPFamilyPermissions"
        }
      },
      cmFamilyPermissions: {
        serializedName: "cmFamilyPermissions",
        type: {
          name: "Composite",
          className: "ITPFamilyPermissions"
        }
      },
      isAdult: {
        serializedName: "isAdult",
        type: {
          name: "Boolean"
        }
      },
      consentsRequested: {
        serializedName: "consentsRequested",
        type: {
          name: "Number"
        }
      },
      maxConsentRequestsAllowed: {
        serializedName: "maxConsentRequestsAllowed",
        type: {
          name: "Number"
        }
      },
      isITPOnboardingSupported: {
        serializedName: "isITPOnboardingSupported",
        type: {
          name: "Boolean"
        }
      },
      isCMOnboardingSupported: {
        serializedName: "isCMOnboardingSupported",
        type: {
          name: "Boolean"
        }
      },
      totalBreachCount: {
        serializedName: "totalBreachCount",
        type: {
          name: "Number"
        }
      },
      activeBreachCount: {
        serializedName: "activeBreachCount",
        type: {
          name: "Number"
        }
      },
      creditScore: {
        serializedName: "creditScore",
        type: {
          name: "String"
        }
      },
      creditScoreRating: {
        serializedName: "creditScoreRating",
        type: {
          name: "String"
        }
      },
      previousCreditScore: {
        serializedName: "previousCreditScore",
        type: {
          name: "String"
        }
      },
      formattedCreditScoreWithRating: {
        serializedName: "formattedCreditScoreWithRating",
        type: {
          name: "String"
        }
      },
      showCreditScore: {
        serializedName: "showCreditScore",
        type: {
          name: "Boolean"
        }
      },
      totalCreditAlertsCount: {
        serializedName: "totalCreditAlertsCount",
        type: {
          name: "Number"
        }
      },
      activeCreditAlertsCount: {
        serializedName: "activeCreditAlertsCount",
        type: {
          name: "Number"
        }
      },
      photoUrl: {
        serializedName: "photoUrl",
        type: {
          name: "String"
        }
      },
      userInfo: {
        serializedName: "userInfo",
        type: {
          name: "Composite",
          className: "UserInfo"
        }
      }
    }
  }
};

export const NotificationSettingPayload: coreHttp.CompositeMapper = {
  serializedName: "NotificationSettingPayload",
  type: {
    name: "Composite",
    className: "NotificationSettingPayload",
    modelProperties: {
      settingType: {
        required: true,
        serializedName: "settingType",
        type: {
          name: "Enum",
          allowedValues: [
            "FamilyMemberNotification",
            "FamilyMemberNotificationTopic",
            "FamilyNotification",
            "SelfNotificationChannel",
            "SelfNotificationTopic"
          ]
        }
      },
      isEnabled: {
        required: true,
        serializedName: "isEnabled",
        type: {
          name: "Boolean"
        }
      },
      memberUserId: {
        serializedName: "memberUserId",
        type: {
          name: "String"
        }
      },
      topicId: {
        serializedName: "topicId",
        type: {
          name: "String"
        }
      },
      channel: {
        serializedName: "channel",
        type: {
          name: "Enum",
          allowedValues: [
            "Push",
            "Email"
          ]
        }
      }
    }
  }
};

export const NotificationSettingResponse: coreHttp.CompositeMapper = {
  serializedName: "NotificationSettingResponse",
  type: {
    name: "Composite",
    className: "NotificationSettingResponse",
    modelProperties: {
      settingId: {
        required: true,
        serializedName: "settingId",
        type: {
          name: "String"
        }
      },
      lastModifiedDateTime: {
        serializedName: "lastModifiedDateTime",
        type: {
          name: "DateTime"
        }
      },
      settingType: {
        required: true,
        serializedName: "settingType",
        type: {
          name: "Enum",
          allowedValues: [
            "FamilyMemberNotification",
            "FamilyMemberNotificationTopic",
            "FamilyNotification",
            "SelfNotificationChannel",
            "SelfNotificationTopic"
          ]
        }
      },
      isEnabled: {
        required: true,
        serializedName: "isEnabled",
        type: {
          name: "Boolean"
        }
      },
      memberUserId: {
        serializedName: "memberUserId",
        type: {
          name: "String"
        }
      },
      topicId: {
        serializedName: "topicId",
        type: {
          name: "String"
        }
      },
      channel: {
        serializedName: "channel",
        type: {
          name: "Enum",
          allowedValues: [
            "Push",
            "Email"
          ]
        }
      }
    }
  }
};

export const ActionButton: coreHttp.CompositeMapper = {
  serializedName: "ActionButton",
  type: {
    name: "Composite",
    className: "ActionButton",
    modelProperties: {
      type: {
        serializedName: "type",
        type: {
          name: "String"
        }
      },
      url: {
        serializedName: "url",
        type: {
          name: "String"
        }
      },
      landingPageType: {
        serializedName: "landingPageType",
        type: {
          name: "String"
        }
      },
      displayText: {
        serializedName: "displayText",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const ImageUrl: coreHttp.CompositeMapper = {
  serializedName: "ImageUrl",
  type: {
    name: "Composite",
    className: "ImageUrl",
    modelProperties: {
      lightModeUrl: {
        serializedName: "lightModeUrl",
        type: {
          name: "String"
        }
      },
      darkModeUrl: {
        serializedName: "darkModeUrl",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const NotificationResponse: coreHttp.CompositeMapper = {
  serializedName: "NotificationResponse",
  type: {
    name: "Composite",
    className: "NotificationResponse",
    modelProperties: {
      notificationId: {
        serializedName: "notificationId",
        type: {
          name: "String"
        }
      },
      actionButtons: {
        serializedName: "actionButtons",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ActionButton"
            }
          }
        }
      },
      imageUrl: {
        serializedName: "imageUrl",
        type: {
          name: "Composite",
          className: "ImageUrl"
        }
      },
      title: {
        serializedName: "title",
        type: {
          name: "String"
        }
      },
      subTitle: {
        serializedName: "subTitle",
        type: {
          name: "String"
        }
      },
      defaultActionButton: {
        serializedName: "defaultActionButton",
        type: {
          name: "Composite",
          className: "ActionButton"
        }
      },
      eventGroupType: {
        serializedName: "eventGroupType",
        type: {
          name: "String"
        }
      },
      unsupportedClientDefaultAction: {
        serializedName: "unsupportedClientDefaultAction",
        type: {
          name: "String"
        }
      },
      isSilentNotification: {
        serializedName: "isSilentNotification",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const RecommendationAction: coreHttp.CompositeMapper = {
  serializedName: "RecommendationAction",
  type: {
    name: "Composite",
    className: "RecommendationAction",
    modelProperties: {
      type: {
        serializedName: "type",
        type: {
          name: "Enum",
          allowedValues: [
            "TakeAction",
            "Dismiss"
          ]
        }
      },
      buttonText: {
        serializedName: "buttonText",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const Recommendation: coreHttp.CompositeMapper = {
  serializedName: "Recommendation",
  type: {
    name: "Composite",
    className: "Recommendation",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      type: {
        serializedName: "type",
        type: {
          name: "String"
        }
      },
      title: {
        serializedName: "title",
        type: {
          name: "String"
        }
      },
      subtitle: {
        serializedName: "subtitle",
        type: {
          name: "String"
        }
      },
      webViewUrl: {
        serializedName: "webViewUrl",
        type: {
          name: "String"
        }
      },
      actions: {
        serializedName: "actions",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "RecommendationAction"
            }
          }
        }
      }
    }
  }
};

export const RewardActivity: coreHttp.CompositeMapper = {
  serializedName: "RewardActivity",
  type: {
    name: "Composite",
    className: "RewardActivity",
    modelProperties: {
      campaignId: {
        required: true,
        serializedName: "campaignId",
        type: {
          name: "String"
        }
      },
      title: {
        required: true,
        serializedName: "title",
        type: {
          name: "String"
        }
      },
      subtitle: {
        required: true,
        serializedName: "subtitle",
        type: {
          name: "String"
        }
      },
      categoryId: {
        required: true,
        serializedName: "categoryId",
        type: {
          name: "String"
        }
      },
      points: {
        required: true,
        serializedName: "points",
        type: {
          name: "Number"
        }
      },
      rewardsDashboardUrl: {
        required: true,
        serializedName: "rewardsDashboardUrl",
        type: {
          name: "String"
        }
      },
      deviceId: {
        serializedName: "deviceId",
        type: {
          name: "String"
        }
      },
      devicePlatform: {
        serializedName: "devicePlatform",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const TrustedNetwork: coreHttp.CompositeMapper = {
  serializedName: "TrustedNetwork",
  type: {
    name: "Composite",
    className: "TrustedNetwork",
    modelProperties: {
      id: {
        required: true,
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      ssid: {
        required: true,
        serializedName: "ssid",
        type: {
          name: "String"
        }
      },
      bssid: {
        required: true,
        serializedName: "bssid",
        type: {
          name: "String"
        }
      },
      verdict: {
        required: true,
        serializedName: "verdict",
        type: {
          name: "String"
        }
      },
      lastModifiedDateTime: {
        required: true,
        serializedName: "lastModifiedDateTime",
        type: {
          name: "DateTime"
        }
      },
      createdDateTime: {
        required: true,
        serializedName: "createdDateTime",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const NewTrustedNetworkRequest: coreHttp.CompositeMapper = {
  serializedName: "NewTrustedNetworkRequest",
  type: {
    name: "Composite",
    className: "NewTrustedNetworkRequest",
    modelProperties: {
      ssid: {
        required: true,
        serializedName: "ssid",
        type: {
          name: "String"
        }
      },
      bssid: {
        required: true,
        serializedName: "bssid",
        type: {
          name: "String"
        }
      },
      verdict: {
        required: true,
        serializedName: "verdict",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const PaymentHistory: coreHttp.CompositeMapper = {
  serializedName: "PaymentHistory",
  type: {
    name: "Composite",
    className: "PaymentHistory",
    modelProperties: {
      year: {
        required: true,
        serializedName: "year",
        type: {
          name: "Number"
        }
      },
      jan: {
        serializedName: "jan",
        type: {
          name: "Enum",
          allowedValues: [
            "Grey",
            "Green",
            "Red"
          ]
        }
      },
      feb: {
        serializedName: "feb",
        type: {
          name: "Enum",
          allowedValues: [
            "Grey",
            "Green",
            "Red"
          ]
        }
      },
      mar: {
        serializedName: "mar",
        type: {
          name: "Enum",
          allowedValues: [
            "Grey",
            "Green",
            "Red"
          ]
        }
      },
      apr: {
        serializedName: "apr",
        type: {
          name: "Enum",
          allowedValues: [
            "Grey",
            "Green",
            "Red"
          ]
        }
      },
      may: {
        serializedName: "may",
        type: {
          name: "Enum",
          allowedValues: [
            "Grey",
            "Green",
            "Red"
          ]
        }
      },
      jun: {
        serializedName: "jun",
        type: {
          name: "Enum",
          allowedValues: [
            "Grey",
            "Green",
            "Red"
          ]
        }
      },
      jul: {
        serializedName: "jul",
        type: {
          name: "Enum",
          allowedValues: [
            "Grey",
            "Green",
            "Red"
          ]
        }
      },
      aug: {
        serializedName: "aug",
        type: {
          name: "Enum",
          allowedValues: [
            "Grey",
            "Green",
            "Red"
          ]
        }
      },
      sep: {
        serializedName: "sep",
        type: {
          name: "Enum",
          allowedValues: [
            "Grey",
            "Green",
            "Red"
          ]
        }
      },
      oct: {
        serializedName: "oct",
        type: {
          name: "Enum",
          allowedValues: [
            "Grey",
            "Green",
            "Red"
          ]
        }
      },
      nov: {
        serializedName: "nov",
        type: {
          name: "Enum",
          allowedValues: [
            "Grey",
            "Green",
            "Red"
          ]
        }
      },
      dec: {
        serializedName: "dec",
        type: {
          name: "Enum",
          allowedValues: [
            "Grey",
            "Green",
            "Red"
          ]
        }
      }
    }
  }
};

export const CreditorInfo: coreHttp.CompositeMapper = {
  serializedName: "CreditorInfo",
  type: {
    name: "Composite",
    className: "CreditorInfo",
    modelProperties: {
      name: {
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      phone: {
        serializedName: "phone",
        type: {
          name: "String"
        }
      },
      addressLine: {
        serializedName: "addressLine",
        type: {
          name: "String"
        }
      },
      city: {
        serializedName: "city",
        type: {
          name: "String"
        }
      },
      state: {
        serializedName: "state",
        type: {
          name: "String"
        }
      },
      zip: {
        serializedName: "zip",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const Account: coreHttp.CompositeMapper = {
  serializedName: "Account",
  type: {
    name: "Composite",
    className: "Account",
    modelProperties: {
      accountStatus: {
        serializedName: "accountStatus",
        type: {
          name: "Enum",
          allowedValues: [
            "Closed",
            "Negative",
            "GoodStanding"
          ]
        }
      },
      paymentStatus: {
        serializedName: "paymentStatus",
        type: {
          name: "String"
        }
      },
      iconUrl: {
        serializedName: "iconUrl",
        type: {
          name: "String"
        }
      },
      accountName: {
        serializedName: "accountName",
        type: {
          name: "String"
        }
      },
      accountClassification: {
        serializedName: "accountClassification",
        type: {
          name: "Enum",
          allowedValues: [
            "Revolving",
            "Installment",
            "RealEstate",
            "Collection",
            "Other"
          ]
        }
      },
      accountType: {
        serializedName: "accountType",
        type: {
          name: "String"
        }
      },
      accountNumber: {
        serializedName: "accountNumber",
        type: {
          name: "String"
        }
      },
      balance: {
        serializedName: "balance",
        type: {
          name: "Number"
        }
      },
      openDate: {
        serializedName: "openDate",
        type: {
          name: "DateTime"
        }
      },
      statusDate: {
        serializedName: "statusDate",
        type: {
          name: "DateTime"
        }
      },
      limit: {
        serializedName: "limit",
        type: {
          name: "Number"
        }
      },
      responsibility: {
        serializedName: "responsibility",
        type: {
          name: "String"
        }
      },
      highBalance: {
        serializedName: "highBalance",
        type: {
          name: "Number"
        }
      },
      delinquent30DaysCount: {
        serializedName: "delinquent30DaysCount",
        type: {
          name: "Number"
        }
      },
      delinquent60DaysCount: {
        serializedName: "delinquent60DaysCount",
        type: {
          name: "Number"
        }
      },
      delinquent90DaysCount: {
        serializedName: "delinquent90DaysCount",
        type: {
          name: "Number"
        }
      },
      paymentHistory: {
        serializedName: "paymentHistory",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "PaymentHistory"
            }
          }
        }
      },
      creditorInfo: {
        serializedName: "creditorInfo",
        type: {
          name: "Composite",
          className: "CreditorInfo"
        }
      },
      recommendations: {
        serializedName: "recommendations",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      }
    }
  }
};

export const BankAccountDetails: coreHttp.CompositeMapper = {
  serializedName: "BankAccountDetails",
  type: {
    name: "Composite",
    className: "BankAccountDetails",
    modelProperties: {
      accountNumber: {
        required: true,
        serializedName: "accountNumber",
        type: {
          name: "String"
        }
      },
      routingNumber: {
        required: true,
        serializedName: "routingNumber",
        type: {
          name: "String"
        }
      },
      index: {
        required: true,
        serializedName: "index",
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const CreditCardNumber: coreHttp.CompositeMapper = {
  serializedName: "CreditCardNumber",
  type: {
    name: "Composite",
    className: "CreditCardNumber",
    modelProperties: {
      cardNumber: {
        required: true,
        serializedName: "cardNumber",
        type: {
          name: "String"
        }
      },
      index: {
        required: true,
        serializedName: "index",
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const DebitCardNumber: coreHttp.CompositeMapper = {
  serializedName: "DebitCardNumber",
  type: {
    name: "Composite",
    className: "DebitCardNumber",
    modelProperties: {
      cardNumber: {
        required: true,
        serializedName: "cardNumber",
        type: {
          name: "String"
        }
      },
      index: {
        required: true,
        serializedName: "index",
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const AccountDetails: coreHttp.CompositeMapper = {
  serializedName: "AccountDetails",
  type: {
    name: "Composite",
    className: "AccountDetails",
    modelProperties: {
      bankAccounts: {
        serializedName: "bankAccounts",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BankAccountDetails"
            }
          }
        }
      },
      creditCardNumbers: {
        serializedName: "creditCardNumbers",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CreditCardNumber"
            }
          }
        }
      },
      debitCardNumbers: {
        serializedName: "debitCardNumbers",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DebitCardNumber"
            }
          }
        }
      },
      hashedBankAccounts: {
        serializedName: "hashedBankAccounts",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BankAccountDetails"
            }
          }
        }
      },
      hashedCreditCardNumbers: {
        serializedName: "hashedCreditCardNumbers",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CreditCardNumber"
            }
          }
        }
      },
      hashedDebitCardNumbers: {
        serializedName: "hashedDebitCardNumbers",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DebitCardNumber"
            }
          }
        }
      }
    }
  }
};

export const AcknowledgmentRequest: coreHttp.CompositeMapper = {
  serializedName: "AcknowledgmentRequest",
  type: {
    name: "Composite",
    className: "AcknowledgmentRequest",
    modelProperties: {
      notificationIds: {
        required: true,
        serializedName: "notificationIds",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      }
    }
  }
};

export const AddressDetails: coreHttp.CompositeMapper = {
  serializedName: "AddressDetails",
  type: {
    name: "Composite",
    className: "AddressDetails",
    modelProperties: {
      addressLine: {
        serializedName: "addressLine",
        type: {
          name: "String"
        }
      },
      city: {
        serializedName: "city",
        type: {
          name: "String"
        }
      },
      state: {
        serializedName: "state",
        type: {
          name: "String"
        }
      },
      zip: {
        serializedName: "zip",
        type: {
          name: "String"
        }
      },
      firstReportedDateTime: {
        serializedName: "firstReportedDateTime",
        type: {
          name: "DateTime"
        }
      },
      lastUpdatedDateTime: {
        serializedName: "lastUpdatedDateTime",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const AggregatedThreat: coreHttp.CompositeMapper = {
  serializedName: "AggregatedThreat",
  type: {
    name: "Composite",
    className: "AggregatedThreat",
    modelProperties: {
      lastModifiedThreat: {
        serializedName: "lastModifiedThreat",
        type: {
          name: "Composite",
          className: "Threat"
        }
      },
      lastModifiedDateTime: {
        serializedName: "lastModifiedDateTime",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const AggregatedUnsafeUrl: coreHttp.CompositeMapper = {
  serializedName: "AggregatedUnsafeUrl",
  type: {
    name: "Composite",
    className: "AggregatedUnsafeUrl",
    modelProperties: {
      lastModifiedUnsafeUrl: {
        serializedName: "lastModifiedUnsafeUrl",
        type: {
          name: "Composite",
          className: "UnsafeUrl"
        }
      },
      lastModifiedDateTime: {
        serializedName: "lastModifiedDateTime",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const AggregatedDeviceProtectionHistory: coreHttp.CompositeMapper = {
  serializedName: "AggregatedDeviceProtectionHistory",
  type: {
    name: "Composite",
    className: "AggregatedDeviceProtectionHistory",
    modelProperties: {
      detectedThreats: {
        serializedName: "detectedThreats",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AggregatedThreat"
            }
          }
        }
      },
      detectedUnsafeUrls: {
        serializedName: "detectedUnsafeUrls",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AggregatedUnsafeUrl"
            }
          }
        }
      }
    }
  }
};

export const RecommendationsProgress: coreHttp.CompositeMapper = {
  serializedName: "RecommendationsProgress",
  type: {
    name: "Composite",
    className: "RecommendationsProgress",
    modelProperties: {
      total: {
        required: true,
        serializedName: "total",
        type: {
          name: "Number"
        }
      },
      completed: {
        required: true,
        serializedName: "completed",
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const Alert: coreHttp.CompositeMapper = {
  serializedName: "Alert",
  type: {
    name: "Composite",
    className: "Alert",
    modelProperties: {
      id: {
        required: true,
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      eventType: {
        required: true,
        serializedName: "eventType",
        type: {
          name: "Enum",
          allowedValues: [
            "DeviceAdded",
            "DeviceRemoved",
            "DeviceSignedOut",
            "DeviceThreat",
            "DeviceRtpOff",
            "DeviceRtpOn",
            "PhishingLink",
            "AntiphishingOff",
            "AntiphishingOn",
            "DeviceScanCompleted",
            "ITPBreachCritical",
            "ITPBreachHigh",
            "ITPBreachMedium",
            "ITPBreachInformational",
            "ITPDelegationRequest",
            "ITPSharingRequest",
            "DeviceRtpSetting",
            "AntiphishingSetting",
            "SecureConnectionConsumerVpnMonthlyQuota",
            "ITMCreditEventHigh",
            "ITMCreditEventNormal",
            "AutoSampleSubmissionSetting",
            "DeviceThreatDetected",
            "DeviceThreatResolved"
          ]
        }
      },
      category: {
        required: true,
        serializedName: "category",
        type: {
          name: "Enum",
          allowedValues: [
            "Info",
            "Threat"
          ]
        }
      },
      severity: {
        required: true,
        serializedName: "severity",
        type: {
          name: "Enum",
          allowedValues: [
            "Info",
            "Low",
            "Medium",
            "High",
            "Important",
            "Critical"
          ]
        }
      },
      status: {
        serializedName: "status",
        type: {
          name: "Enum",
          allowedValues: [
            "None",
            "Allowed",
            "Blocked",
            "Quarantined",
            "Removed",
            "Bypassed",
            "Threat",
            "Compromised",
            "InProgress",
            "Complete",
            "Cleaned",
            "Restored",
            "RemediationFailed",
            "Detected",
            "ProtectionOn",
            "ProtectionOff",
            "NeedsAttention",
            "Archived"
          ]
        }
      },
      isRead: {
        serializedName: "isRead",
        type: {
          name: "Boolean"
        }
      },
      dismissType: {
        serializedName: "dismissType",
        type: {
          name: "Enum",
          allowedValues: [
            "None",
            "Dismiss",
            "SaveForLater"
          ]
        }
      },
      isDismissed: {
        serializedName: "isDismissed",
        type: {
          name: "Boolean"
        }
      },
      isDismissedLastModifiedDateTime: {
        serializedName: "isDismissedLastModifiedDateTime",
        type: {
          name: "DateTime"
        }
      },
      isActive: {
        serializedName: "isActive",
        type: {
          name: "Boolean"
        }
      },
      isVisibleOnDashboard: {
        readOnly: true,
        serializedName: "isVisibleOnDashboard",
        type: {
          name: "Boolean"
        }
      },
      createdDateTime: {
        serializedName: "createdDateTime",
        type: {
          name: "DateTime"
        }
      },
      lastModifiedDateTime: {
        serializedName: "lastModifiedDateTime",
        type: {
          name: "DateTime"
        }
      },
      expirationDateTime: {
        serializedName: "expirationDateTime",
        type: {
          name: "DateTime"
        }
      },
      artifactType: {
        required: true,
        serializedName: "artifactType",
        type: {
          name: "Enum",
          allowedValues: [
            "Device",
            "IdentityMonitoringBreach",
            "ItpConsentRequest",
            "ItpNotification",
            "SecureConnection",
            "Credit"
          ]
        }
      },
      artifactId: {
        required: true,
        serializedName: "artifactId",
        type: {
          name: "String"
        }
      },
      linkId: {
        serializedName: "linkId",
        type: {
          name: "String"
        }
      },
      artifactName: {
        required: true,
        serializedName: "artifactName",
        type: {
          name: "String"
        }
      },
      artifactDetailType: {
        serializedName: "artifactDetailType",
        type: {
          name: "Enum",
          allowedValues: [
            "Device",
            "DeviceProtectionHistory"
          ]
        }
      },
      isGroup: {
        serializedName: "isGroup",
        type: {
          name: "Boolean"
        }
      },
      artifactDetailId: {
        required: true,
        serializedName: "artifactDetailId",
        type: {
          name: "String"
        }
      },
      devicePlatform: {
        serializedName: "devicePlatform",
        type: {
          name: "Enum",
          allowedValues: [
            "Windows",
            "Android",
            "iOS",
            "macOS",
            "Unknown"
          ]
        }
      },
      body: {
        serializedName: "body",
        type: {
          name: "Object"
        }
      },
      title: {
        serializedName: "title",
        type: {
          name: "String"
        }
      },
      subtitle: {
        serializedName: "subtitle",
        type: {
          name: "String"
        }
      },
      dashboardTitle: {
        serializedName: "dashboardTitle",
        type: {
          name: "String"
        }
      },
      dashboardSubtitle: {
        serializedName: "dashboardSubtitle",
        type: {
          name: "String"
        }
      },
      description: {
        serializedName: "description",
        type: {
          name: "String"
        }
      },
      statusDescription: {
        serializedName: "statusDescription",
        type: {
          name: "String"
        }
      },
      detailsApiUrl: {
        serializedName: "detailsApiUrl",
        type: {
          name: "String"
        }
      },
      detailsWebviewUrl: {
        serializedName: "detailsWebviewUrl",
        type: {
          name: "String"
        }
      },
      associatedUsers: {
        serializedName: "associatedUsers",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AssociatedUser"
            }
          }
        }
      },
      actions: {
        serializedName: "actions",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "None",
                "Dismiss",
                "SaveForLater",
                "TakeAction",
                "SeeDetails"
              ]
            }
          }
        }
      },
      recommendationsProgress: {
        serializedName: "recommendationsProgress",
        type: {
          name: "Composite",
          className: "RecommendationsProgress"
        }
      },
      version: {
        serializedName: "version",
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const PaginationMetadata: coreHttp.CompositeMapper = {
  serializedName: "PaginationMetadata",
  type: {
    name: "Composite",
    className: "PaginationMetadata",
    modelProperties: {
      totalItemCount: {
        serializedName: "totalItemCount",
        type: {
          name: "Number"
        }
      },
      totalActiveItemCount: {
        serializedName: "totalActiveItemCount",
        type: {
          name: "Number"
        }
      },
      totalActiveItemCountForCurrentUser: {
        serializedName: "totalActiveItemCountForCurrentUser",
        type: {
          name: "Number"
        }
      },
      activeItemCount: {
        serializedName: "activeItemCount",
        type: {
          name: "Number"
        }
      },
      totalPageCount: {
        serializedName: "totalPageCount",
        type: {
          name: "Number"
        }
      },
      currentPage: {
        serializedName: "currentPage",
        type: {
          name: "Number"
        }
      },
      pageSize: {
        serializedName: "pageSize",
        type: {
          name: "Number"
        }
      },
      nextPageLink: {
        serializedName: "nextPageLink",
        type: {
          name: "String"
        }
      },
      previousPageLink: {
        serializedName: "previousPageLink",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const AlertsInfo: coreHttp.CompositeMapper = {
  serializedName: "AlertsInfo",
  type: {
    name: "Composite",
    className: "AlertsInfo",
    modelProperties: {
      alerts: {
        serializedName: "alerts",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Alert"
            }
          }
        }
      },
      paginationMetadata: {
        serializedName: "paginationMetadata",
        type: {
          name: "Composite",
          className: "PaginationMetadata"
        }
      }
    }
  }
};

export const FamilyPermission: coreHttp.CompositeMapper = {
  serializedName: "FamilyPermission",
  type: {
    name: "Composite",
    className: "FamilyPermission",
    modelProperties: {
      canToggle: {
        serializedName: "canToggle",
        type: {
          name: "Boolean"
        }
      },
      lastModified: {
        serializedName: "lastModified",
        type: {
          name: "DateTime"
        }
      },
      familyPermissionType: {
        serializedName: "familyPermissionType",
        type: {
          name: "Enum",
          allowedValues: [
            "DevicesStatus",
            "ITPManage",
            "ITPRead",
            "CreditMonitoringRead",
            "CreditMonitoringManage"
          ]
        }
      },
      value: {
        serializedName: "value",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const AllFamilyPermissions: coreHttp.CompositeMapper = {
  serializedName: "AllFamilyPermissions",
  type: {
    name: "Composite",
    className: "AllFamilyPermissions",
    modelProperties: {
      permissions: {
        serializedName: "permissions",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "FamilyPermission"
            }
          }
        }
      },
      familyOrganizers: {
        serializedName: "familyOrganizers",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AssociatedUser"
            }
          }
        }
      }
    }
  }
};

export const SelfNotificationTopicSettingResponse: coreHttp.CompositeMapper = {
  serializedName: "SelfNotificationTopicSettingResponse",
  type: {
    name: "Composite",
    className: "SelfNotificationTopicSettingResponse",
    modelProperties: {
      settingType: {
        required: true,
        serializedName: "settingType",
        type: {
          name: "Enum",
          allowedValues: [
            "FamilyMemberNotification",
            "FamilyMemberNotificationTopic",
            "FamilyNotification",
            "SelfNotificationChannel",
            "SelfNotificationTopic"
          ]
        }
      },
      topicId: {
        required: true,
        serializedName: "topicId",
        type: {
          name: "String"
        }
      },
      topicName: {
        required: true,
        serializedName: "topicName",
        type: {
          name: "String"
        }
      },
      topicShortName: {
        required: true,
        serializedName: "topicShortName",
        type: {
          name: "String"
        }
      },
      channel: {
        required: true,
        serializedName: "channel",
        type: {
          name: "Enum",
          allowedValues: [
            "Push",
            "Email"
          ]
        }
      },
      isEnabled: {
        required: true,
        serializedName: "isEnabled",
        type: {
          name: "Boolean"
        }
      },
      disabledReason: {
        serializedName: "disabledReason",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const FamilyMemberNotificationTopicSettingResponse: coreHttp.CompositeMapper = {
  serializedName: "FamilyMemberNotificationTopicSettingResponse",
  type: {
    name: "Composite",
    className: "FamilyMemberNotificationTopicSettingResponse",
    modelProperties: {
      settingType: {
        required: true,
        serializedName: "settingType",
        type: {
          name: "Enum",
          allowedValues: [
            "FamilyMemberNotification",
            "FamilyMemberNotificationTopic",
            "FamilyNotification",
            "SelfNotificationChannel",
            "SelfNotificationTopic"
          ]
        }
      },
      memberUserId: {
        required: true,
        serializedName: "memberUserId",
        type: {
          name: "String"
        }
      },
      topicId: {
        required: true,
        serializedName: "topicId",
        type: {
          name: "String"
        }
      },
      topicName: {
        required: true,
        serializedName: "topicName",
        type: {
          name: "String"
        }
      },
      topicShortName: {
        required: true,
        serializedName: "topicShortName",
        type: {
          name: "String"
        }
      },
      channel: {
        required: true,
        serializedName: "channel",
        type: {
          name: "Enum",
          allowedValues: [
            "Push",
            "Email"
          ]
        }
      },
      isEnabled: {
        required: true,
        serializedName: "isEnabled",
        type: {
          name: "Boolean"
        }
      },
      disabledReason: {
        serializedName: "disabledReason",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const FamilyMemberAllNotificationSettings: coreHttp.CompositeMapper = {
  serializedName: "FamilyMemberAllNotificationSettings",
  type: {
    name: "Composite",
    className: "FamilyMemberAllNotificationSettings",
    modelProperties: {
      memberUserId: {
        required: true,
        serializedName: "memberUserId",
        type: {
          name: "String"
        }
      },
      memberName: {
        serializedName: "memberName",
        type: {
          name: "String"
        }
      },
      pushNotifications: {
        required: true,
        serializedName: "pushNotifications",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "FamilyMemberNotificationTopicSettingResponse"
            }
          }
        }
      },
      emailNotifications: {
        required: true,
        serializedName: "emailNotifications",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "FamilyMemberNotificationTopicSettingResponse"
            }
          }
        }
      }
    }
  }
};

export const AllNotificationSettings: coreHttp.CompositeMapper = {
  serializedName: "AllNotificationSettings",
  type: {
    name: "Composite",
    className: "AllNotificationSettings",
    modelProperties: {
      hasError: {
        required: true,
        serializedName: "hasError",
        type: {
          name: "Boolean"
        }
      },
      pushNotifications: {
        required: true,
        serializedName: "pushNotifications",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SelfNotificationTopicSettingResponse"
            }
          }
        }
      },
      emailNotifications: {
        required: true,
        serializedName: "emailNotifications",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SelfNotificationTopicSettingResponse"
            }
          }
        }
      },
      familyMemberNotificationSettings: {
        serializedName: "familyMemberNotificationSettings",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "FamilyMemberAllNotificationSettings"
            }
          }
        }
      }
    }
  }
};

export const AnswerOption: coreHttp.CompositeMapper = {
  serializedName: "AnswerOption",
  type: {
    name: "Composite",
    className: "AnswerOption",
    modelProperties: {
      answerNumber: {
        serializedName: "answerNumber",
        type: {
          name: "String"
        }
      },
      answer: {
        serializedName: "answer",
        type: {
          name: "String"
        }
      },
      answerChoiceId: {
        serializedName: "answerChoiceId",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const AppLinksSettings: coreHttp.CompositeMapper = {
  serializedName: "AppLinksSettings",
  type: {
    name: "Composite",
    className: "AppLinksSettings",
    modelProperties: {
      default: {
        serializedName: "default",
        type: {
          name: "String"
        }
      },
      win32: {
        serializedName: "win32",
        type: {
          name: "String"
        }
      },
      win64: {
        serializedName: "win64",
        type: {
          name: "String"
        }
      },
      android: {
        serializedName: "android",
        type: {
          name: "String"
        }
      },
      macOS: {
        serializedName: "macOS",
        type: {
          name: "String"
        }
      },
      ios: {
        serializedName: "ios",
        type: {
          name: "String"
        }
      },
      link: {
        serializedName: "link",
        type: {
          name: "String"
        }
      },
      qrLink: {
        serializedName: "qrLink",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const BandwidthUsage: coreHttp.CompositeMapper = {
  serializedName: "BandwidthUsage",
  type: {
    name: "Composite",
    className: "BandwidthUsage",
    modelProperties: {
      bandwidthUsageInGB: {
        serializedName: "bandwidthUsageInGB",
        type: {
          name: "Number"
        }
      },
      prevMonthBandwidthUsageInGB: {
        serializedName: "prevMonthBandwidthUsageInGB",
        type: {
          name: "Number"
        }
      },
      bandwidthUsageInPercentage: {
        serializedName: "bandwidthUsageInPercentage",
        type: {
          name: "Number"
        }
      },
      totalAvailableBandwidthInGB: {
        serializedName: "totalAvailableBandwidthInGB",
        type: {
          name: "Number"
        }
      },
      daysRemaining: {
        serializedName: "daysRemaining",
        type: {
          name: "Number"
        }
      },
      postFUPSpeedInKBPS: {
        serializedName: "postFUPSpeedInKBPS",
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const BetaCapacityData: coreHttp.CompositeMapper = {
  serializedName: "BetaCapacityData",
  type: {
    name: "Composite",
    className: "BetaCapacityData",
    modelProperties: {
      isAndroidCapReached: {
        serializedName: "isAndroidCapReached",
        type: {
          name: "Boolean"
        }
      },
      isIOSCapReached: {
        serializedName: "isIOSCapReached",
        type: {
          name: "Boolean"
        }
      },
      isMacOSCapReached: {
        serializedName: "isMacOSCapReached",
        type: {
          name: "Boolean"
        }
      },
      isWindowsCapReached: {
        serializedName: "isWindowsCapReached",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const ChatTokenUsage: coreHttp.CompositeMapper = {
  serializedName: "ChatTokenUsage",
  type: {
    name: "Composite",
    className: "ChatTokenUsage",
    modelProperties: {
      promptTokens: {
        serializedName: "promptTokens",
        type: {
          name: "Number"
        }
      },
      completionTokens: {
        serializedName: "completionTokens",
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const RequiredSSNDOB: coreHttp.CompositeMapper = {
  serializedName: "RequiredSSNDOB",
  type: {
    name: "Composite",
    className: "RequiredSSNDOB",
    modelProperties: {
      ssn: {
        serializedName: "ssn",
        type: {
          name: "String"
        }
      },
      dob: {
        serializedName: "dob",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const ChildSSNApiRequest: coreHttp.CompositeMapper = {
  serializedName: "ChildSSNApiRequest",
  type: {
    name: "Composite",
    className: "ChildSSNApiRequest",
    modelProperties: {
      ssndob: {
        required: true,
        serializedName: "ssndob",
        type: {
          name: "Composite",
          className: "RequiredSSNDOB"
        }
      }
    }
  }
};

export const FullName: coreHttp.CompositeMapper = {
  serializedName: "FullName",
  type: {
    name: "Composite",
    className: "FullName",
    modelProperties: {
      firstName: {
        serializedName: "firstName",
        type: {
          name: "String"
        }
      },
      middleInitial: {
        serializedName: "middleInitial",
        type: {
          name: "String"
        }
      },
      lastName: {
        serializedName: "lastName",
        type: {
          name: "String"
        }
      },
      generation: {
        serializedName: "generation",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const FullAddress: coreHttp.CompositeMapper = {
  serializedName: "FullAddress",
  type: {
    name: "Composite",
    className: "FullAddress",
    modelProperties: {
      address1: {
        serializedName: "address1",
        type: {
          name: "String"
        }
      },
      address2: {
        serializedName: "address2",
        type: {
          name: "String"
        }
      },
      city: {
        serializedName: "city",
        type: {
          name: "String"
        }
      },
      state: {
        serializedName: "state",
        type: {
          name: "String"
        }
      },
      zipCode: {
        serializedName: "zipCode",
        type: {
          name: "String"
        }
      },
      countryCode: {
        serializedName: "countryCode",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const Telephone: coreHttp.CompositeMapper = {
  serializedName: "Telephone",
  type: {
    name: "Composite",
    className: "Telephone",
    modelProperties: {
      number: {
        serializedName: "number",
        type: {
          name: "String"
        }
      },
      type: {
        serializedName: "type",
        type: {
          name: "String"
        }
      },
      primary: {
        serializedName: "primary",
        type: {
          name: "Boolean"
        }
      },
      verified: {
        serializedName: "verified",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const NotificationPreference: coreHttp.CompositeMapper = {
  serializedName: "NotificationPreference",
  type: {
    name: "Composite",
    className: "NotificationPreference",
    modelProperties: {
      email: {
        serializedName: "email",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const Notifications: coreHttp.CompositeMapper = {
  serializedName: "Notifications",
  type: {
    name: "Composite",
    className: "Notifications",
    modelProperties: {
      telephoneDetails: {
        serializedName: "telephoneDetails",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Telephone"
            }
          }
        }
      },
      emailAddress: {
        serializedName: "emailAddress",
        type: {
          name: "String"
        }
      },
      notificationPreference: {
        serializedName: "notificationPreference",
        type: {
          name: "Composite",
          className: "NotificationPreference"
        }
      }
    }
  }
};

export const MinorChild: coreHttp.CompositeMapper = {
  serializedName: "MinorChild",
  type: {
    name: "Composite",
    className: "MinorChild",
    modelProperties: {
      firstName: {
        serializedName: "firstName",
        type: {
          name: "String"
        }
      },
      lastName: {
        serializedName: "lastName",
        type: {
          name: "String"
        }
      },
      ssn: {
        serializedName: "ssn",
        type: {
          name: "String"
        }
      },
      dob: {
        serializedName: "dob",
        type: {
          name: "DateTime"
        }
      },
      verified: {
        serializedName: "verified",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const DriverLicense: coreHttp.CompositeMapper = {
  serializedName: "DriverLicense",
  type: {
    name: "Composite",
    className: "DriverLicense",
    modelProperties: {
      driverLicenseNumber: {
        required: true,
        serializedName: "driverLicenseNumber",
        type: {
          name: "String"
        }
      },
      driverLicenseState: {
        required: true,
        serializedName: "driverLicenseState",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const Passport: coreHttp.CompositeMapper = {
  serializedName: "Passport",
  type: {
    name: "Composite",
    className: "Passport",
    modelProperties: {
      passportNumber: {
        required: true,
        serializedName: "passportNumber",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const NationalId: coreHttp.CompositeMapper = {
  serializedName: "NationalId",
  type: {
    name: "Composite",
    className: "NationalId",
    modelProperties: {
      id: {
        required: true,
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      nationalCountryCode: {
        required: true,
        serializedName: "nationalCountryCode",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const CyberData: coreHttp.CompositeMapper = {
  serializedName: "CyberData",
  type: {
    name: "Composite",
    className: "CyberData",
    modelProperties: {
      telephoneNumbers: {
        serializedName: "telephoneNumbers",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      emailAddresses: {
        serializedName: "emailAddresses",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      medicalIds: {
        serializedName: "medicalIds",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      ibans: {
        serializedName: "ibans",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      otherCards: {
        serializedName: "otherCards",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      driverLicense: {
        serializedName: "driverLicense",
        type: {
          name: "Composite",
          className: "DriverLicense"
        }
      },
      passports: {
        serializedName: "passports",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Passport"
            }
          }
        }
      },
      nationalIds: {
        serializedName: "nationalIds",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "NationalId"
            }
          }
        }
      },
      accountDetails: {
        serializedName: "accountDetails",
        type: {
          name: "Composite",
          className: "AccountDetails"
        }
      },
      hashedMedicalIds: {
        serializedName: "hashedMedicalIds",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      hashedIbans: {
        serializedName: "hashedIbans",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      hashedOtherCards: {
        serializedName: "hashedOtherCards",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      hashedDriverLicense: {
        serializedName: "hashedDriverLicense",
        type: {
          name: "Composite",
          className: "DriverLicense"
        }
      },
      hashedPassports: {
        serializedName: "hashedPassports",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Passport"
            }
          }
        }
      },
      hashedNationalIds: {
        serializedName: "hashedNationalIds",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "NationalId"
            }
          }
        }
      }
    }
  }
};

export const UnverifiedContactInfo: coreHttp.CompositeMapper = {
  serializedName: "UnverifiedContactInfo",
  type: {
    name: "Composite",
    className: "UnverifiedContactInfo",
    modelProperties: {
      telephoneNumbers: {
        serializedName: "telephoneNumbers",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      emailAddresses: {
        serializedName: "emailAddresses",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      }
    }
  }
};

export const MonitoredTypeData: coreHttp.CompositeMapper = {
  serializedName: "MonitoredTypeData",
  type: {
    name: "Composite",
    className: "MonitoredTypeData",
    modelProperties: {
      webViewUrl: {
        serializedName: "webViewUrl",
        type: {
          name: "String"
        }
      },
      type: {
        serializedName: "type",
        type: {
          name: "Enum",
          allowedValues: [
            "TelephoneNumber",
            "EmailAddress",
            "MedicalID",
            "Iban",
            "OtherCard",
            "DriverLicense",
            "Passport",
            "NationalId",
            "BankAccount",
            "CreditCard",
            "DebitCard",
            "SSN"
          ]
        }
      },
      maxCount: {
        serializedName: "maxCount",
        type: {
          name: "Number"
        }
      },
      count: {
        serializedName: "count",
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const MonitoredData: coreHttp.CompositeMapper = {
  serializedName: "MonitoredData",
  type: {
    name: "Composite",
    className: "MonitoredData",
    modelProperties: {
      monitoredTypeData: {
        serializedName: "monitoredTypeData",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "MonitoredTypeData"
            }
          }
        }
      }
    }
  }
};

export const MSAEmailAddress: coreHttp.CompositeMapper = {
  serializedName: "MSAEmailAddress",
  type: {
    name: "Composite",
    className: "MSAEmailAddress",
    modelProperties: {
      emailAddress: {
        serializedName: "emailAddress",
        type: {
          name: "String"
        }
      },
      isVerified: {
        serializedName: "isVerified",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const MSATelephoneNumber: coreHttp.CompositeMapper = {
  serializedName: "MSATelephoneNumber",
  type: {
    name: "Composite",
    className: "MSATelephoneNumber",
    modelProperties: {
      telephoneNumber: {
        serializedName: "telephoneNumber",
        type: {
          name: "String"
        }
      },
      isVerified: {
        serializedName: "isVerified",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const MSAData: coreHttp.CompositeMapper = {
  serializedName: "MSAData",
  type: {
    name: "Composite",
    className: "MSAData",
    modelProperties: {
      emailAddresses: {
        serializedName: "emailAddresses",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "MSAEmailAddress"
            }
          }
        }
      },
      telephoneNumbers: {
        serializedName: "telephoneNumbers",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "MSATelephoneNumber"
            }
          }
        }
      }
    }
  }
};

export const CompleteSubscriberProfileApiResponse: coreHttp.CompositeMapper = {
  serializedName: "CompleteSubscriberProfileApiResponse",
  type: {
    name: "Composite",
    className: "CompleteSubscriberProfileApiResponse",
    modelProperties: {
      displayName: {
        serializedName: "displayName",
        type: {
          name: "String"
        }
      },
      ssnAvailable: {
        serializedName: "ssnAvailable",
        type: {
          name: "Boolean"
        }
      },
      typeNumber: {
        serializedName: "typeNumber",
        type: {
          name: "String"
        }
      },
      fullName: {
        serializedName: "fullName",
        type: {
          name: "Composite",
          className: "FullName"
        }
      },
      fullAddress: {
        serializedName: "fullAddress",
        type: {
          name: "Composite",
          className: "FullAddress"
        }
      },
      notifications: {
        serializedName: "notifications",
        type: {
          name: "Composite",
          className: "Notifications"
        }
      },
      subscriberLangCode: {
        serializedName: "subscriberLangCode",
        type: {
          name: "String"
        }
      },
      minorChildDetails: {
        serializedName: "minorChildDetails",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "MinorChild"
            }
          }
        }
      },
      webActive: {
        serializedName: "webActive",
        type: {
          name: "String"
        }
      },
      active: {
        serializedName: "active",
        type: {
          name: "Boolean"
        }
      },
      secondary: {
        serializedName: "secondary",
        type: {
          name: "Boolean"
        }
      },
      subscriberPartnerStatus: {
        serializedName: "subscriberPartnerStatus",
        type: {
          name: "String"
        }
      },
      cbStatus: {
        required: true,
        serializedName: "cbStatus",
        type: {
          name: "Enum",
          allowedValues: [
            "OnlineAuthenticationPending",
            "OnlineAuthenticationPassed",
            "OnlineAuthenticationFailed",
            "Blank",
            "Deactivated"
          ]
        }
      },
      ssnValidationStatus: {
        serializedName: "ssnValidationStatus",
        type: {
          name: "Enum",
          allowedValues: [
            "NotAvailable",
            "NotStarted",
            "SSNFailed",
            "SSNRegistered"
          ]
        }
      },
      disclosureDateTime: {
        serializedName: "disclosureDateTime",
        type: {
          name: "DateTime"
        }
      },
      futureDeactivationDate: {
        serializedName: "futureDeactivationDate",
        type: {
          name: "DateTime"
        }
      },
      futureActivationDate: {
        serializedName: "futureActivationDate",
        type: {
          name: "DateTime"
        }
      },
      securityQACaptured: {
        serializedName: "securityQACaptured",
        type: {
          name: "String"
        }
      },
      dob: {
        serializedName: "dob",
        type: {
          name: "DateTime"
        }
      },
      cyberData: {
        serializedName: "cyberData",
        type: {
          name: "Composite",
          className: "CyberData"
        }
      },
      isSSNVerified: {
        required: true,
        serializedName: "isSSNVerified",
        type: {
          name: "Boolean"
        }
      },
      unverifiedContactInfo: {
        serializedName: "unverifiedContactInfo",
        type: {
          name: "Composite",
          className: "UnverifiedContactInfo"
        }
      },
      monitoredData: {
        serializedName: "monitoredData",
        type: {
          name: "Composite",
          className: "MonitoredData"
        }
      },
      msaData: {
        serializedName: "msaData",
        type: {
          name: "Composite",
          className: "MSAData"
        }
      }
    }
  }
};

export const CompositeBreachEntity: coreHttp.CompositeMapper = {
  serializedName: "CompositeBreachEntity",
  type: {
    name: "Composite",
    className: "CompositeBreachEntity",
    modelProperties: {
      entityId: {
        serializedName: "entityId",
        type: {
          name: "String"
        }
      },
      compositeBreachType: {
        serializedName: "compositeBreachType",
        type: {
          name: "Enum",
          allowedValues: [
            "Address"
          ]
        }
      },
      breachEntityIds: {
        serializedName: "breachEntityIds",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      breachEntityIdsType: {
        serializedName: "breachEntityIdsType",
        type: {
          name: "String"
        }
      },
      state: {
        serializedName: "state",
        type: {
          name: "Enum",
          allowedValues: [
            "Remediated",
            "FalsePositive",
            "NotRelevant",
            "New"
          ]
        }
      },
      lastModifiedDate: {
        serializedName: "lastModifiedDate",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const ConsumerSecurityErrorResponse: coreHttp.CompositeMapper = {
  serializedName: "ConsumerSecurityErrorResponse",
  type: {
    name: "Composite",
    className: "ConsumerSecurityErrorResponse",
    modelProperties: {
      exceptionCode: {
        readOnly: true,
        serializedName: "exceptionCode",
        type: {
          name: "Number"
        }
      },
      statusCode: {
        readOnly: true,
        serializedName: "statusCode",
        type: {
          name: "Number"
        }
      },
      properties: {
        readOnly: true,
        serializedName: "properties",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "Object"
            }
          }
        }
      },
      message: {
        serializedName: "message",
        type: {
          name: "String"
        }
      },
      data: {
        readOnly: true,
        serializedName: "data",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "Object"
            }
          }
        }
      },
      innerException: {
        serializedName: "innerException",
        type: {
          name: "Object"
        }
      },
      helpLink: {
        serializedName: "helpLink",
        type: {
          name: "String"
        }
      },
      source: {
        serializedName: "source",
        type: {
          name: "String"
        }
      },
      hResult: {
        serializedName: "hResult",
        type: {
          name: "Number"
        }
      },
      stackTrace: {
        readOnly: true,
        serializedName: "stackTrace",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const ConsumerVpnResponse: coreHttp.CompositeMapper = {
  serializedName: "ConsumerVpnResponse",
  type: {
    name: "Composite",
    className: "ConsumerVpnResponse",
    modelProperties: {
      isOnboardingSupported: {
        serializedName: "isOnboardingSupported",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const CreditAlertRecommendation: coreHttp.CompositeMapper = {
  serializedName: "CreditAlertRecommendation",
  type: {
    name: "Composite",
    className: "CreditAlertRecommendation",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      recommendationType: {
        serializedName: "recommendationType",
        type: {
          name: "Enum",
          allowedValues: [
            "SigninToAccountAndCheckDetails",
            "CheckJointOwnerOfCardOrAccount",
            "ContactCreditorForMoreInformation",
            "StillDontRecognizeActivityFileDisputeWithExperian",
            "FileADisputeWithExperian",
            "AppliedOrCosignedForNewServiceAccountOrLoan",
            "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
            "ContactInquirerByMail",
            "ContactInquirerCompany",
            "ContactIdentityValidatorCompany",
            "ContactCompanyForMoreInformation",
            "SSNTrace",
            "CreditFileLocked",
            "CreditFileUnlocked",
            "CreditFileUnlockedDueToMembershipChange",
            "InquiryBlocked",
            "ContactExperianCreditLockStatus",
            "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
          ]
        }
      },
      isCompleted: {
        serializedName: "isCompleted",
        type: {
          name: "Boolean"
        }
      },
      resolvedDate: {
        serializedName: "resolvedDate",
        type: {
          name: "DateTime"
        }
      },
      createdDate: {
        serializedName: "createdDate",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const Subscriber: coreHttp.CompositeMapper = {
  serializedName: "Subscriber",
  type: {
    name: "Composite",
    className: "Subscriber",
    modelProperties: {
      name: {
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      phone: {
        serializedName: "phone",
        type: {
          name: "String"
        }
      },
      businessType: {
        serializedName: "businessType",
        type: {
          name: "String"
        }
      },
      addressLine: {
        serializedName: "addressLine",
        type: {
          name: "String"
        }
      },
      city: {
        serializedName: "city",
        type: {
          name: "String"
        }
      },
      state: {
        serializedName: "state",
        type: {
          name: "String"
        }
      },
      zip: {
        serializedName: "zip",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const PublicRecordDetails: coreHttp.CompositeMapper = {
  serializedName: "PublicRecordDetails",
  type: {
    name: "Composite",
    className: "PublicRecordDetails",
    modelProperties: {
      amount: {
        serializedName: "amount",
        type: {
          name: "Number"
        }
      },
      courtName: {
        serializedName: "courtName",
        type: {
          name: "String"
        }
      },
      fileDate: {
        serializedName: "fileDate",
        type: {
          name: "DateTime"
        }
      },
      subscriber: {
        serializedName: "subscriber",
        type: {
          name: "Composite",
          className: "Subscriber"
        }
      }
    }
  }
};

export const NewAddressDetails: coreHttp.CompositeMapper = {
  serializedName: "NewAddressDetails",
  type: {
    name: "Composite",
    className: "NewAddressDetails",
    modelProperties: {
      currentAddress: {
        serializedName: "currentAddress",
        type: {
          name: "Composite",
          className: "AddressDetails"
        }
      },
      oldAddress: {
        serializedName: "oldAddress",
        type: {
          name: "Composite",
          className: "AddressDetails"
        }
      }
    }
  }
};

export const NewAccountDetails: coreHttp.CompositeMapper = {
  serializedName: "NewAccountDetails",
  type: {
    name: "Composite",
    className: "NewAccountDetails",
    modelProperties: {
      balanceDate: {
        serializedName: "balanceDate",
        type: {
          name: "DateTime"
        }
      },
      balanceAmount: {
        serializedName: "balanceAmount",
        type: {
          name: "Number"
        }
      },
      openDate: {
        serializedName: "openDate",
        type: {
          name: "DateTime"
        }
      },
      statusDate: {
        serializedName: "statusDate",
        type: {
          name: "DateTime"
        }
      },
      subscriber: {
        serializedName: "subscriber",
        type: {
          name: "Composite",
          className: "Subscriber"
        }
      }
    }
  }
};

export const InquiryDetails: coreHttp.CompositeMapper = {
  serializedName: "InquiryDetails",
  type: {
    name: "Composite",
    className: "InquiryDetails",
    modelProperties: {
      inquiryDate: {
        serializedName: "inquiryDate",
        type: {
          name: "DateTime"
        }
      },
      subscriber: {
        serializedName: "subscriber",
        type: {
          name: "Composite",
          className: "Subscriber"
        }
      }
    }
  }
};

export const PotentiallyNegativeDetails: coreHttp.CompositeMapper = {
  serializedName: "PotentiallyNegativeDetails",
  type: {
    name: "Composite",
    className: "PotentiallyNegativeDetails",
    modelProperties: {
      balanceAmount: {
        serializedName: "balanceAmount",
        type: {
          name: "Number"
        }
      },
      isCollection: {
        serializedName: "isCollection",
        type: {
          name: "Boolean"
        }
      },
      openDate: {
        serializedName: "openDate",
        type: {
          name: "DateTime"
        }
      },
      statusDate: {
        serializedName: "statusDate",
        type: {
          name: "DateTime"
        }
      },
      paymentStatus: {
        serializedName: "paymentStatus",
        type: {
          name: "String"
        }
      },
      subscriber: {
        serializedName: "subscriber",
        type: {
          name: "Composite",
          className: "Subscriber"
        }
      }
    }
  }
};

export const CreditDetails: coreHttp.CompositeMapper = {
  serializedName: "CreditDetails",
  type: {
    name: "Composite",
    className: "CreditDetails",
    modelProperties: {
      creditLimit: {
        serializedName: "creditLimit",
        type: {
          name: "Number"
        }
      },
      previousCreditLimit: {
        serializedName: "previousCreditLimit",
        type: {
          name: "Number"
        }
      },
      balanceAmount: {
        serializedName: "balanceAmount",
        type: {
          name: "Number"
        }
      },
      previousBalanceAmount: {
        serializedName: "previousBalanceAmount",
        type: {
          name: "Number"
        }
      },
      balanceDate: {
        serializedName: "balanceDate",
        type: {
          name: "DateTime"
        }
      },
      previousBalanceDate: {
        serializedName: "previousBalanceDate",
        type: {
          name: "DateTime"
        }
      },
      subscriber: {
        serializedName: "subscriber",
        type: {
          name: "Composite",
          className: "Subscriber"
        }
      }
    }
  }
};

export const PositiveActivityDetails: coreHttp.CompositeMapper = {
  serializedName: "PositiveActivityDetails",
  type: {
    name: "Composite",
    className: "PositiveActivityDetails",
    modelProperties: {
      noticeDate: {
        serializedName: "noticeDate",
        type: {
          name: "DateTime"
        }
      },
      previousStatus: {
        serializedName: "previousStatus",
        type: {
          name: "String"
        }
      },
      currentStatus: {
        serializedName: "currentStatus",
        type: {
          name: "String"
        }
      },
      subscriber: {
        serializedName: "subscriber",
        type: {
          name: "Composite",
          className: "Subscriber"
        }
      }
    }
  }
};

export const DormantActivityDetails: coreHttp.CompositeMapper = {
  serializedName: "DormantActivityDetails",
  type: {
    name: "Composite",
    className: "DormantActivityDetails",
    modelProperties: {
      balanceDate: {
        serializedName: "balanceDate",
        type: {
          name: "DateTime"
        }
      },
      balanceAmount: {
        serializedName: "balanceAmount",
        type: {
          name: "Number"
        }
      },
      subscriber: {
        serializedName: "subscriber",
        type: {
          name: "Composite",
          className: "Subscriber"
        }
      }
    }
  }
};

export const CreditLockDetails: coreHttp.CompositeMapper = {
  serializedName: "CreditLockDetails",
  type: {
    name: "Composite",
    className: "CreditLockDetails",
    modelProperties: {
      lockEndDateTime: {
        serializedName: "lockEndDateTime",
        type: {
          name: "DateTime"
        }
      },
      inquiryDate: {
        serializedName: "inquiryDate",
        type: {
          name: "DateTime"
        }
      },
      subscriber: {
        serializedName: "subscriber",
        type: {
          name: "Composite",
          className: "Subscriber"
        }
      },
      triggerDescription: {
        serializedName: "triggerDescription",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const IdentityValidationDetails: coreHttp.CompositeMapper = {
  serializedName: "IdentityValidationDetails",
  type: {
    name: "Composite",
    className: "IdentityValidationDetails",
    modelProperties: {
      subscriber: {
        serializedName: "subscriber",
        type: {
          name: "Composite",
          className: "Subscriber"
        }
      }
    }
  }
};

export const NewApplicationDetails: coreHttp.CompositeMapper = {
  serializedName: "NewApplicationDetails",
  type: {
    name: "Composite",
    className: "NewApplicationDetails",
    modelProperties: {
      subscriber: {
        serializedName: "subscriber",
        type: {
          name: "Composite",
          className: "Subscriber"
        }
      }
    }
  }
};

export const SSNDetails: coreHttp.CompositeMapper = {
  serializedName: "SSNDetails",
  type: {
    name: "Composite",
    className: "SSNDetails",
    modelProperties: {
      addressLine: {
        serializedName: "addressLine",
        type: {
          name: "String"
        }
      },
      city: {
        serializedName: "city",
        type: {
          name: "String"
        }
      },
      state: {
        serializedName: "state",
        type: {
          name: "String"
        }
      },
      zip: {
        serializedName: "zip",
        type: {
          name: "String"
        }
      },
      firstName: {
        serializedName: "firstName",
        type: {
          name: "String"
        }
      },
      lastName: {
        serializedName: "lastName",
        type: {
          name: "String"
        }
      },
      phone: {
        serializedName: "phone",
        type: {
          name: "String"
        }
      },
      source: {
        serializedName: "source",
        type: {
          name: "String"
        }
      },
      dateOfBirth: {
        serializedName: "dateOfBirth",
        type: {
          name: "DateTime"
        }
      },
      firstRecordedDate: {
        serializedName: "firstRecordedDate",
        type: {
          name: "DateTime"
        }
      },
      rank: {
        serializedName: "rank",
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const SSNTraceRecordDetails: coreHttp.CompositeMapper = {
  serializedName: "SSNTraceRecordDetails",
  type: {
    name: "Composite",
    className: "SSNTraceRecordDetails",
    modelProperties: {
      addressLine: {
        serializedName: "addressLine",
        type: {
          name: "String"
        }
      },
      city: {
        serializedName: "city",
        type: {
          name: "String"
        }
      },
      state: {
        serializedName: "state",
        type: {
          name: "String"
        }
      },
      zip: {
        serializedName: "zip",
        type: {
          name: "String"
        }
      },
      firstName: {
        serializedName: "firstName",
        type: {
          name: "String"
        }
      },
      lastName: {
        serializedName: "lastName",
        type: {
          name: "String"
        }
      },
      phone: {
        serializedName: "phone",
        type: {
          name: "String"
        }
      },
      source: {
        serializedName: "source",
        type: {
          name: "String"
        }
      },
      dateOfBirth: {
        serializedName: "dateOfBirth",
        type: {
          name: "DateTime"
        }
      },
      firstRecordedDate: {
        serializedName: "firstRecordedDate",
        type: {
          name: "DateTime"
        }
      },
      rank: {
        serializedName: "rank",
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const CreditAlert: coreHttp.CompositeMapper = {
  serializedName: "CreditAlert",
  type: {
    name: "Composite",
    className: "CreditAlert",
    modelProperties: {
      id: {
        required: true,
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      iconUrl: {
        serializedName: "iconUrl",
        type: {
          name: "String"
        }
      },
      alertDateTime: {
        serializedName: "alertDateTime",
        type: {
          name: "DateTime"
        }
      },
      userFeedback: {
        serializedName: "userFeedback",
        type: {
          name: "Enum",
          allowedValues: [
            "New",
            "WasMe",
            "DoNotRecognize"
          ]
        }
      },
      userFeedbackDateTime: {
        serializedName: "userFeedbackDateTime",
        type: {
          name: "DateTime"
        }
      },
      recommendations: {
        serializedName: "recommendations",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CreditAlertRecommendation"
            }
          }
        }
      },
      alertType: {
        required: true,
        serializedName: "alertType",
        type: {
          name: "Enum",
          allowedValues: [
            "PublicRecordBankruptcy",
            "PublicRecordLiensAndJudgements",
            "PublicRecordSettlement",
            "NewAddress",
            "NewAccount",
            "NewInquiry",
            "PotentiallyNegativeTradelineBankruptcy",
            "PotentiallyNegativeMajorDerogatory",
            "PotentiallyNegativeDelinquent",
            "PotentiallyNegativeSkipCannotLocate",
            "PotentiallyNegativeLostOrStolenCard",
            "PotentiallyNegativeDeceased",
            "PotentiallyNegativeCardOverLimit",
            "PotentiallyNegativeSettlement",
            "CreditLimitIncrease",
            "CreditLimitDecrease",
            "CreditUsageIncrease",
            "CreditUsageDecrease",
            "CreditBalanceIncrease",
            "CreditBalanceDecrease",
            "PositiveActivityAccountPaid",
            "PositiveActivityAccountClosed",
            "PositiveActivityAccountImproved",
            "PositiveActivityAccountCurrent",
            "DormantActivityHomeEquity",
            "DormantActivityUnsecuredLineOfCredit",
            "DormantActivityBankCard",
            "DormantActivityRetailCard",
            "CreditLockLocked",
            "CreditLockUnlocked",
            "CreditLockUnlockedDueToMembershipChange",
            "CreditLockInquiryBlocked",
            "IdentityValidation",
            "NewApplication",
            "SSNTrace",
            "Unknown"
          ]
        }
      },
      publicRecordDetails: {
        serializedName: "publicRecordDetails",
        type: {
          name: "Composite",
          className: "PublicRecordDetails"
        }
      },
      addressDetails: {
        serializedName: "addressDetails",
        type: {
          name: "Composite",
          className: "NewAddressDetails"
        }
      },
      accountDetails: {
        serializedName: "accountDetails",
        type: {
          name: "Composite",
          className: "NewAccountDetails"
        }
      },
      inquiryDetails: {
        serializedName: "inquiryDetails",
        type: {
          name: "Composite",
          className: "InquiryDetails"
        }
      },
      potentiallyNegativeDetails: {
        serializedName: "potentiallyNegativeDetails",
        type: {
          name: "Composite",
          className: "PotentiallyNegativeDetails"
        }
      },
      creditDetails: {
        serializedName: "creditDetails",
        type: {
          name: "Composite",
          className: "CreditDetails"
        }
      },
      positiveActivityDetails: {
        serializedName: "positiveActivityDetails",
        type: {
          name: "Composite",
          className: "PositiveActivityDetails"
        }
      },
      dormantActivityDetails: {
        serializedName: "dormantActivityDetails",
        type: {
          name: "Composite",
          className: "DormantActivityDetails"
        }
      },
      creditLockDetails: {
        serializedName: "creditLockDetails",
        type: {
          name: "Composite",
          className: "CreditLockDetails"
        }
      },
      identityValidationDetails: {
        serializedName: "identityValidationDetails",
        type: {
          name: "Composite",
          className: "IdentityValidationDetails"
        }
      },
      newApplicationDetails: {
        serializedName: "newApplicationDetails",
        type: {
          name: "Composite",
          className: "NewApplicationDetails"
        }
      },
      ssnDetails: {
        serializedName: "ssnDetails",
        type: {
          name: "Composite",
          className: "SSNDetails"
        }
      },
      ssnTraceRecordDetails: {
        serializedName: "ssnTraceRecordDetails",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SSNTraceRecordDetails"
            }
          }
        }
      },
      isArchived: {
        serializedName: "isArchived",
        type: {
          name: "Boolean"
        }
      },
      archivedDateTime: {
        serializedName: "archivedDateTime",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const CreditAlertRequest: coreHttp.CompositeMapper = {
  serializedName: "CreditAlertRequest",
  type: {
    name: "Composite",
    className: "CreditAlertRequest",
    modelProperties: {
      userFeedback: {
        serializedName: "userFeedback",
        type: {
          name: "Enum",
          allowedValues: [
            "New",
            "WasMe",
            "DoNotRecognize"
          ]
        }
      },
      isArchived: {
        serializedName: "isArchived",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const CreditInquiry: coreHttp.CompositeMapper = {
  serializedName: "CreditInquiry",
  type: {
    name: "Composite",
    className: "CreditInquiry",
    modelProperties: {
      companyName: {
        serializedName: "companyName",
        type: {
          name: "String"
        }
      },
      iconUrl: {
        serializedName: "iconUrl",
        type: {
          name: "String"
        }
      },
      inquiryDateTime: {
        serializedName: "inquiryDateTime",
        type: {
          name: "DateTime"
        }
      },
      companyType: {
        serializedName: "companyType",
        type: {
          name: "String"
        }
      },
      creditorInfo: {
        serializedName: "creditorInfo",
        type: {
          name: "Composite",
          className: "CreditorInfo"
        }
      },
      recommendations: {
        serializedName: "recommendations",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      }
    }
  }
};

export const Name: coreHttp.CompositeMapper = {
  serializedName: "Name",
  type: {
    name: "Composite",
    className: "Name",
    modelProperties: {
      lastName: {
        serializedName: "lastName",
        type: {
          name: "String"
        }
      },
      middleName: {
        serializedName: "middleName",
        type: {
          name: "String"
        }
      },
      firstName: {
        serializedName: "firstName",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const Employer: coreHttp.CompositeMapper = {
  serializedName: "Employer",
  type: {
    name: "Composite",
    className: "Employer",
    modelProperties: {
      name: {
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      firstReportedDateTime: {
        serializedName: "firstReportedDateTime",
        type: {
          name: "DateTime"
        }
      },
      lastUpdatedDateTime: {
        serializedName: "lastUpdatedDateTime",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const PersonalInfo: coreHttp.CompositeMapper = {
  serializedName: "PersonalInfo",
  type: {
    name: "Composite",
    className: "PersonalInfo",
    modelProperties: {
      names: {
        serializedName: "names",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Name"
            }
          }
        }
      },
      employers: {
        serializedName: "employers",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Employer"
            }
          }
        }
      },
      addresses: {
        serializedName: "addresses",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AddressDetails"
            }
          }
        }
      },
      phone: {
        serializedName: "phone",
        type: {
          name: "String"
        }
      },
      dateOfBirth: {
        serializedName: "dateOfBirth",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const PublicRecord: coreHttp.CompositeMapper = {
  serializedName: "PublicRecord",
  type: {
    name: "Composite",
    className: "PublicRecord",
    modelProperties: {
      court: {
        serializedName: "court",
        type: {
          name: "String"
        }
      },
      iconUrl: {
        serializedName: "iconUrl",
        type: {
          name: "String"
        }
      },
      amount: {
        serializedName: "amount",
        type: {
          name: "Number"
        }
      },
      recordType: {
        serializedName: "recordType",
        type: {
          name: "String"
        }
      },
      referenceNumber: {
        serializedName: "referenceNumber",
        type: {
          name: "String"
        }
      },
      responsibility: {
        serializedName: "responsibility",
        type: {
          name: "String"
        }
      },
      comments: {
        serializedName: "comments",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      filedBy: {
        serializedName: "filedBy",
        type: {
          name: "String"
        }
      },
      filedDate: {
        serializedName: "filedDate",
        type: {
          name: "DateTime"
        }
      },
      statusDate: {
        serializedName: "statusDate",
        type: {
          name: "DateTime"
        }
      },
      liability: {
        serializedName: "liability",
        type: {
          name: "String"
        }
      },
      asset: {
        serializedName: "asset",
        type: {
          name: "String"
        }
      },
      recommendations: {
        serializedName: "recommendations",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "SigninToAccountAndCheckDetails",
                "CheckJointOwnerOfCardOrAccount",
                "ContactCreditorForMoreInformation",
                "StillDontRecognizeActivityFileDisputeWithExperian",
                "FileADisputeWithExperian",
                "AppliedOrCosignedForNewServiceAccountOrLoan",
                "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
                "ContactInquirerByMail",
                "ContactInquirerCompany",
                "ContactIdentityValidatorCompany",
                "ContactCompanyForMoreInformation",
                "SSNTrace",
                "CreditFileLocked",
                "CreditFileUnlocked",
                "CreditFileUnlockedDueToMembershipChange",
                "InquiryBlocked",
                "ContactExperianCreditLockStatus",
                "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
              ]
            }
          }
        }
      }
    }
  }
};

export const CreditReport: coreHttp.CompositeMapper = {
  serializedName: "CreditReport",
  type: {
    name: "Composite",
    className: "CreditReport",
    modelProperties: {
      reportDateTime: {
        serializedName: "reportDateTime",
        type: {
          name: "DateTime"
        }
      },
      nextReportDate: {
        serializedName: "nextReportDate",
        type: {
          name: "DateTime"
        }
      },
      personalInfo: {
        serializedName: "personalInfo",
        type: {
          name: "Composite",
          className: "PersonalInfo"
        }
      },
      accounts: {
        serializedName: "accounts",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Account"
            }
          }
        }
      },
      creditInquiries: {
        serializedName: "creditInquiries",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CreditInquiry"
            }
          }
        }
      },
      publicRecords: {
        serializedName: "publicRecords",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "PublicRecord"
            }
          }
        }
      }
    }
  }
};

export const ScoreDetails: coreHttp.CompositeMapper = {
  serializedName: "ScoreDetails",
  type: {
    name: "Composite",
    className: "ScoreDetails",
    modelProperties: {
      creditScore: {
        serializedName: "creditScore",
        type: {
          name: "String"
        }
      },
      creditScoreDateTime: {
        serializedName: "creditScoreDateTime",
        type: {
          name: "DateTime"
        }
      },
      creditScoreRating: {
        serializedName: "creditScoreRating",
        type: {
          name: "String"
        }
      },
      previousCreditScore: {
        serializedName: "previousCreditScore",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const CreditSummary: coreHttp.CompositeMapper = {
  serializedName: "CreditSummary",
  type: {
    name: "Composite",
    className: "CreditSummary",
    modelProperties: {
      alerts: {
        serializedName: "alerts",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CreditAlert"
            }
          }
        }
      },
      report: {
        serializedName: "report",
        type: {
          name: "Composite",
          className: "CreditReport"
        }
      },
      score: {
        serializedName: "score",
        type: {
          name: "Composite",
          className: "ScoreDetails"
        }
      }
    }
  }
};

export const RequiredFullName: coreHttp.CompositeMapper = {
  serializedName: "RequiredFullName",
  type: {
    name: "Composite",
    className: "RequiredFullName",
    modelProperties: {
      firstName: {
        required: true,
        serializedName: "firstName",
        type: {
          name: "String"
        }
      },
      lastName: {
        required: true,
        serializedName: "lastName",
        type: {
          name: "String"
        }
      },
      middleInitial: {
        serializedName: "middleInitial",
        type: {
          name: "String"
        }
      },
      generation: {
        serializedName: "generation",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const CsIdPrimaryDataRequest: coreHttp.CompositeMapper = {
  serializedName: "CsIdPrimaryDataRequest",
  type: {
    name: "Composite",
    className: "CsIdPrimaryDataRequest",
    modelProperties: {
      dateOfBirth: {
        required: true,
        serializedName: "dateOfBirth",
        type: {
          name: "DateTime"
        }
      },
      fullName: {
        required: true,
        serializedName: "fullName",
        type: {
          name: "Composite",
          className: "RequiredFullName"
        }
      }
    }
  }
};

export const DateModel: coreHttp.CompositeMapper = {
  serializedName: "Date",
  type: {
    name: "Composite",
    className: "DateModel",
    modelProperties: {
      year: {
        serializedName: "year",
        type: {
          name: "Number"
        }
      },
      month: {
        serializedName: "month",
        type: {
          name: "Number"
        }
      },
      day: {
        serializedName: "day",
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const DefenderChatHistoryItem: coreHttp.CompositeMapper = {
  serializedName: "DefenderChatHistoryItem",
  type: {
    name: "Composite",
    className: "DefenderChatHistoryItem",
    modelProperties: {
      question: {
        serializedName: "question",
        type: {
          name: "String"
        }
      },
      response: {
        serializedName: "response",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const DefenderChatRequest: coreHttp.CompositeMapper = {
  serializedName: "DefenderChatRequest",
  type: {
    name: "Composite",
    className: "DefenderChatRequest",
    modelProperties: {
      question: {
        serializedName: "question",
        type: {
          name: "String"
        }
      },
      history: {
        serializedName: "history",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DefenderChatHistoryItem"
            }
          }
        }
      },
      artifactType: {
        serializedName: "artifactType",
        type: {
          name: "Enum",
          allowedValues: [
            "DeviceAlert",
            "IdentityMonitoringBreach",
            "CreditAlert"
          ]
        }
      },
      artifactId: {
        serializedName: "artifactId",
        type: {
          name: "String"
        }
      },
      useExperimentalModel: {
        serializedName: "useExperimentalModel",
        type: {
          name: "Boolean"
        }
      },
      systemPrompt: {
        serializedName: "systemPrompt",
        type: {
          name: "String"
        }
      },
      temperature: {
        serializedName: "temperature",
        type: {
          name: "Number"
        }
      },
      topP: {
        serializedName: "topP",
        type: {
          name: "Number"
        }
      },
      seed: {
        serializedName: "seed",
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const DefenderChatResponseMetadata: coreHttp.CompositeMapper = {
  serializedName: "DefenderChatResponseMetadata",
  type: {
    name: "Composite",
    className: "DefenderChatResponseMetadata",
    modelProperties: {
      duration: {
        serializedName: "duration",
        type: {
          name: "String"
        }
      },
      searchResult: {
        serializedName: "searchResult",
        type: {
          name: "String"
        }
      },
      functionCallResult: {
        serializedName: "functionCallResult",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "String"
            }
          }
        }
      },
      chatTokenUsage: {
        serializedName: "chatTokenUsage",
        type: {
          name: "Composite",
          className: "ChatTokenUsage"
        }
      }
    }
  }
};

export const DefenderChatResponse: coreHttp.CompositeMapper = {
  serializedName: "DefenderChatResponse",
  type: {
    name: "Composite",
    className: "DefenderChatResponse",
    modelProperties: {
      message: {
        serializedName: "message",
        type: {
          name: "String"
        }
      },
      metadata: {
        serializedName: "metadata",
        type: {
          name: "Composite",
          className: "DefenderChatResponseMetadata"
        }
      }
    }
  }
};

export const DeleteBankAccountRequest: coreHttp.CompositeMapper = {
  serializedName: "DeleteBankAccountRequest",
  type: {
    name: "Composite",
    className: "DeleteBankAccountRequest",
    modelProperties: {
      accountNumber: {
        required: true,
        serializedName: "accountNumber",
        type: {
          name: "String"
        }
      },
      bankRouting: {
        serializedName: "bankRouting",
        type: {
          name: "String"
        }
      },
      index: {
        required: true,
        serializedName: "index",
        constraints: {
          InclusiveMaximum: 19,
          InclusiveMinimum: 0
        },
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const DeleteCreditCardNumbersRequest: coreHttp.CompositeMapper = {
  serializedName: "DeleteCreditCardNumbersRequest",
  type: {
    name: "Composite",
    className: "DeleteCreditCardNumbersRequest",
    modelProperties: {
      cardNumber: {
        required: true,
        serializedName: "cardNumber",
        type: {
          name: "String"
        }
      },
      index: {
        required: true,
        serializedName: "index",
        constraints: {
          InclusiveMaximum: 19,
          InclusiveMinimum: 0
        },
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const DeleteDebitCardNumbersRequest: coreHttp.CompositeMapper = {
  serializedName: "DeleteDebitCardNumbersRequest",
  type: {
    name: "Composite",
    className: "DeleteDebitCardNumbersRequest",
    modelProperties: {
      cardNumber: {
        required: true,
        serializedName: "cardNumber",
        type: {
          name: "String"
        }
      },
      index: {
        required: true,
        serializedName: "index",
        constraints: {
          InclusiveMaximum: 19,
          InclusiveMinimum: 0
        },
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const DeleteAccountDetailsRequest: coreHttp.CompositeMapper = {
  serializedName: "DeleteAccountDetailsRequest",
  type: {
    name: "Composite",
    className: "DeleteAccountDetailsRequest",
    modelProperties: {
      bankAccounts: {
        serializedName: "bankAccounts",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DeleteBankAccountRequest"
            }
          }
        }
      },
      creditCardNumbers: {
        serializedName: "creditCardNumbers",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DeleteCreditCardNumbersRequest"
            }
          }
        }
      },
      debitCardNumbers: {
        serializedName: "debitCardNumbers",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DeleteDebitCardNumbersRequest"
            }
          }
        }
      }
    }
  }
};

export const DeleteDriverLicenseRequest: coreHttp.CompositeMapper = {
  serializedName: "DeleteDriverLicenseRequest",
  type: {
    name: "Composite",
    className: "DeleteDriverLicenseRequest",
    modelProperties: {
      number: {
        serializedName: "number",
        type: {
          name: "String"
        }
      },
      state: {
        serializedName: "state",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const PassportRequest: coreHttp.CompositeMapper = {
  serializedName: "PassportRequest",
  type: {
    name: "Composite",
    className: "PassportRequest",
    modelProperties: {
      passportNumber: {
        serializedName: "passportNumber",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const NationalIdRequest: coreHttp.CompositeMapper = {
  serializedName: "NationalIdRequest",
  type: {
    name: "Composite",
    className: "NationalIdRequest",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      nationalCountryCode: {
        serializedName: "nationalCountryCode",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const UnverifiedPhoneRequest: coreHttp.CompositeMapper = {
  serializedName: "UnverifiedPhoneRequest",
  type: {
    name: "Composite",
    className: "UnverifiedPhoneRequest",
    modelProperties: {
      countryCode: {
        required: true,
        serializedName: "countryCode",
        type: {
          name: "String"
        }
      },
      phoneNumber: {
        required: true,
        serializedName: "phoneNumber",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const DeleteSubscriberCyberDataRequest: coreHttp.CompositeMapper = {
  serializedName: "DeleteSubscriberCyberDataRequest",
  type: {
    name: "Composite",
    className: "DeleteSubscriberCyberDataRequest",
    modelProperties: {
      driverLicense: {
        serializedName: "driverLicense",
        type: {
          name: "Composite",
          className: "DeleteDriverLicenseRequest"
        }
      },
      accountDetails: {
        serializedName: "accountDetails",
        type: {
          name: "Composite",
          className: "DeleteAccountDetailsRequest"
        }
      },
      ibans: {
        serializedName: "ibans",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      otherCards: {
        serializedName: "otherCards",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      passportDetails: {
        serializedName: "passportDetails",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "PassportRequest"
            }
          }
        }
      },
      nationalIdDetails: {
        serializedName: "nationalIdDetails",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "NationalIdRequest"
            }
          }
        }
      },
      unverifiedPhones: {
        serializedName: "unverifiedPhones",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "UnverifiedPhoneRequest"
            }
          }
        }
      },
      isEncrypted: {
        serializedName: "isEncrypted",
        type: {
          name: "Boolean"
        }
      },
      telephoneNumbers: {
        serializedName: "telephoneNumbers",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      emailAddresses: {
        serializedName: "emailAddresses",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      medicalIDs: {
        serializedName: "medicalIDs",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      }
    }
  }
};

export const DeviceCreate: coreHttp.CompositeMapper = {
  serializedName: "DeviceCreate",
  type: {
    name: "Composite",
    className: "DeviceCreate",
    modelProperties: {
      deviceId: {
        serializedName: "deviceId",
        type: {
          name: "String"
        }
      },
      name: {
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      nickname: {
        serializedName: "nickname",
        type: {
          name: "String"
        }
      },
      type: {
        serializedName: "type",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "Desktop",
            "Laptop",
            "Tablet",
            "Mobile",
            "VirtualMachine"
          ]
        }
      },
      model: {
        serializedName: "model",
        type: {
          name: "String"
        }
      },
      platform: {
        serializedName: "platform",
        type: {
          name: "Enum",
          allowedValues: [
            "Windows",
            "Android",
            "iOS",
            "macOS",
            "Unknown"
          ]
        }
      },
      onboardingStatus: {
        serializedName: "onboardingStatus",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "InProgress",
            "Postponed",
            "Completed"
          ]
        }
      },
      osVersion: {
        serializedName: "osVersion",
        type: {
          name: "String"
        }
      },
      serialNumber: {
        serializedName: "serialNumber",
        type: {
          name: "String"
        }
      },
      loginMethod: {
        serializedName: "loginMethod",
        type: {
          name: "String"
        }
      },
      protectionStatus: {
        serializedName: "protectionStatus",
        type: {
          name: "Composite",
          className: "DeviceProtectionStatus"
        }
      }
    }
  }
};

export const DeviceInstallation: coreHttp.CompositeMapper = {
  serializedName: "DeviceInstallation",
  type: {
    name: "Composite",
    className: "DeviceInstallation",
    modelProperties: {
      deviceId: {
        required: true,
        serializedName: "deviceId",
        type: {
          name: "String"
        }
      },
      pushChannel: {
        required: true,
        serializedName: "pushChannel",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const DeviceSummary: coreHttp.CompositeMapper = {
  serializedName: "DeviceSummary",
  type: {
    name: "Composite",
    className: "DeviceSummary",
    modelProperties: {
      deviceId: {
        serializedName: "deviceId",
        type: {
          name: "String"
        }
      },
      name: {
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      nickname: {
        serializedName: "nickname",
        type: {
          name: "String"
        }
      },
      platform: {
        serializedName: "platform",
        type: {
          name: "Enum",
          allowedValues: [
            "Windows",
            "Android",
            "iOS",
            "macOS",
            "Unknown"
          ]
        }
      },
      type: {
        serializedName: "type",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "Desktop",
            "Laptop",
            "Tablet",
            "Mobile",
            "VirtualMachine"
          ]
        }
      },
      model: {
        serializedName: "model",
        type: {
          name: "String"
        }
      },
      healthStatus: {
        serializedName: "healthStatus",
        type: {
          name: "Composite",
          className: "DeviceHealthStatus"
        }
      },
      thirdPartyAvSettings: {
        serializedName: "thirdPartyAvSettings",
        type: {
          name: "Composite",
          className: "ThirdPartyAvSettings"
        }
      },
      lastReportedDateTime: {
        serializedName: "lastReportedDateTime",
        type: {
          name: "DateTime"
        }
      },
      expirationDateTime: {
        serializedName: "expirationDateTime",
        type: {
          name: "DateTime"
        }
      },
      associatedUsers: {
        serializedName: "associatedUsers",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AssociatedUser"
            }
          }
        }
      },
      isSignedOut: {
        serializedName: "isSignedOut",
        type: {
          name: "Boolean"
        }
      },
      isManagedByAdministrator: {
        serializedName: "isManagedByAdministrator",
        type: {
          name: "Boolean"
        }
      },
      canDelete: {
        serializedName: "canDelete",
        type: {
          name: "Boolean"
        }
      },
      loginMethod: {
        serializedName: "loginMethod",
        type: {
          name: "String"
        }
      },
      hasManuallyOpenedApp: {
        serializedName: "hasManuallyOpenedApp",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const DeviceToken: coreHttp.CompositeMapper = {
  serializedName: "DeviceToken",
  type: {
    name: "Composite",
    className: "DeviceToken",
    modelProperties: {
      token: {
        serializedName: "token",
        type: {
          name: "String"
        }
      },
      expirationDateTime: {
        serializedName: "expirationDateTime",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const DeviceUpdate: coreHttp.CompositeMapper = {
  serializedName: "DeviceUpdate",
  type: {
    name: "Composite",
    className: "DeviceUpdate",
    modelProperties: {
      protectionStatus: {
        serializedName: "protectionStatus",
        type: {
          name: "Composite",
          className: "DeviceProtectionStatus"
        }
      },
      onboardingStatus: {
        serializedName: "onboardingStatus",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "InProgress",
            "Postponed",
            "Completed"
          ]
        }
      },
      name: {
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      nickname: {
        serializedName: "nickname",
        type: {
          name: "String"
        }
      },
      osVersion: {
        serializedName: "osVersion",
        type: {
          name: "String"
        }
      },
      lastReportedDateTime: {
        serializedName: "lastReportedDateTime",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const DeviceWideProtectionStatus: coreHttp.CompositeMapper = {
  serializedName: "DeviceWideProtectionStatus",
  type: {
    name: "Composite",
    className: "DeviceWideProtectionStatus",
    modelProperties: {
      healthStatus: {
        serializedName: "healthStatus",
        type: {
          name: "Composite",
          className: "DeviceHealthStatus"
        }
      },
      realTimeProtectionSetting: {
        serializedName: "realTimeProtectionSetting",
        type: {
          name: "Composite",
          className: "ProtectionSetting"
        }
      },
      antiPhishingSetting: {
        serializedName: "antiPhishingSetting",
        type: {
          name: "Composite",
          className: "ProtectionSetting"
        }
      },
      advancedThreatProtectionSetting: {
        serializedName: "advancedThreatProtectionSetting",
        type: {
          name: "Composite",
          className: "ProtectionSetting"
        }
      },
      autoSampleSubmissionSetting: {
        serializedName: "autoSampleSubmissionSetting",
        type: {
          name: "Composite",
          className: "DismissableProtectionSetting"
        }
      },
      autoScanSetting: {
        serializedName: "autoScanSetting",
        type: {
          name: "Composite",
          className: "ProtectionSetting"
        }
      },
      vpnSetting: {
        serializedName: "vpnSetting",
        type: {
          name: "Composite",
          className: "ProtectionSetting"
        }
      },
      saferWifiSetting: {
        serializedName: "saferWifiSetting",
        type: {
          name: "Composite",
          className: "ProtectionSetting"
        }
      },
      cloudDeliveredProtectionSetting: {
        serializedName: "cloudDeliveredProtectionSetting",
        type: {
          name: "Composite",
          className: "ProtectionSetting"
        }
      },
      tamperProtectionSetting: {
        serializedName: "tamperProtectionSetting",
        type: {
          name: "Composite",
          className: "ProtectionSetting"
        }
      },
      defenderProtectionUpdates: {
        serializedName: "defenderProtectionUpdates",
        type: {
          name: "Composite",
          className: "DefenderProtectionUpdates"
        }
      },
      isJailBroken: {
        serializedName: "isJailBroken",
        type: {
          name: "Enum",
          allowedValues: [
            "NotApplicable",
            "True",
            "False"
          ]
        }
      },
      lastScanResults: {
        serializedName: "lastScanResults",
        type: {
          name: "Composite",
          className: "ScanResults"
        }
      },
      activeThreats: {
        serializedName: "activeThreats",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Threat"
            }
          }
        }
      },
      thirdPartyAvSettings: {
        serializedName: "thirdPartyAvSettings",
        type: {
          name: "Composite",
          className: "ThirdPartyAvSettings"
        }
      },
      lastReportedDateTime: {
        serializedName: "lastReportedDateTime",
        type: {
          name: "DateTime"
        }
      },
      isVpnSupported: {
        serializedName: "isVpnSupported",
        type: {
          name: "Boolean"
        }
      },
      isConsumerVpnSupported: {
        serializedName: "isConsumerVpnSupported",
        type: {
          name: "Boolean"
        }
      },
      isSaferWifiSupported: {
        serializedName: "isSaferWifiSupported",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const DeviceWideUpdate: coreHttp.CompositeMapper = {
  serializedName: "DeviceWideUpdate",
  type: {
    name: "Composite",
    className: "DeviceWideUpdate",
    modelProperties: {
      deviceWideProtectionStatus: {
        serializedName: "deviceWideProtectionStatus",
        type: {
          name: "Composite",
          className: "DeviceWideProtectionStatus"
        }
      },
      name: {
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      nickname: {
        serializedName: "nickname",
        type: {
          name: "String"
        }
      },
      osVersion: {
        serializedName: "osVersion",
        type: {
          name: "String"
        }
      },
      lastReportedDateTime: {
        serializedName: "lastReportedDateTime",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const OverallDevicesStatus: coreHttp.CompositeMapper = {
  serializedName: "OverallDevicesStatus",
  type: {
    name: "Composite",
    className: "OverallDevicesStatus",
    modelProperties: {
      totalDevices: {
        serializedName: "totalDevices",
        type: {
          name: "Number"
        }
      },
      devicesToAdd: {
        serializedName: "devicesToAdd",
        type: {
          name: "Number"
        }
      },
      deviceFlaggedForDeletionExpirationTimeInDays: {
        serializedName: "deviceFlaggedForDeletionExpirationTimeInDays",
        type: {
          name: "Number"
        }
      },
      deletedDevices: {
        serializedName: "deletedDevices",
        type: {
          name: "Number"
        }
      },
      unhealthyDevices: {
        serializedName: "unhealthyDevices",
        type: {
          name: "Number"
        }
      },
      overallDevicesHealthStatus: {
        serializedName: "overallDevicesHealthStatus",
        type: {
          name: "Composite",
          className: "DeviceHealthStatus"
        }
      }
    }
  }
};

export const DevicesSummary: coreHttp.CompositeMapper = {
  serializedName: "DevicesSummary",
  type: {
    name: "Composite",
    className: "DevicesSummary",
    modelProperties: {
      overallDevicesStatus: {
        serializedName: "overallDevicesStatus",
        type: {
          name: "Composite",
          className: "OverallDevicesStatus"
        }
      },
      devices: {
        serializedName: "devices",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DeviceSummary"
            }
          }
        }
      },
      deletedDevices: {
        serializedName: "deletedDevices",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DeviceSummary"
            }
          }
        }
      }
    }
  }
};

export const EmailVerificationCodeRequest: coreHttp.CompositeMapper = {
  serializedName: "EmailVerificationCodeRequest",
  type: {
    name: "Composite",
    className: "EmailVerificationCodeRequest",
    modelProperties: {
      emailAddress: {
        required: true,
        serializedName: "emailAddress",
        type: {
          name: "String"
        }
      },
      securityCode: {
        required: true,
        serializedName: "securityCode",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const EmailVerificationGenerateCodeRequest: coreHttp.CompositeMapper = {
  serializedName: "EmailVerificationGenerateCodeRequest",
  type: {
    name: "Composite",
    className: "EmailVerificationGenerateCodeRequest",
    modelProperties: {
      emailAddress: {
        required: true,
        serializedName: "emailAddress",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const FamilyPermissionUpdate: coreHttp.CompositeMapper = {
  serializedName: "FamilyPermissionUpdate",
  type: {
    name: "Composite",
    className: "FamilyPermissionUpdate",
    modelProperties: {
      familyPermissionType: {
        serializedName: "familyPermissionType",
        type: {
          name: "Enum",
          allowedValues: [
            "DevicesStatus",
            "ITPManage",
            "ITPRead",
            "CreditMonitoringRead",
            "CreditMonitoringManage"
          ]
        }
      },
      value: {
        serializedName: "value",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const FamilySharingRequest: coreHttp.CompositeMapper = {
  serializedName: "FamilySharingRequest",
  type: {
    name: "Composite",
    className: "FamilySharingRequest",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const FamilySharingResponse: coreHttp.CompositeMapper = {
  serializedName: "FamilySharingResponse",
  type: {
    name: "Composite",
    className: "FamilySharingResponse",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Boolean"
        }
      },
      itpFamilyPermissions: {
        serializedName: "itpFamilyPermissions",
        type: {
          name: "Composite",
          className: "ITPFamilyPermissions"
        }
      },
      devicePermission: {
        serializedName: "devicePermission",
        type: {
          name: "Composite",
          className: "FamilyPermission"
        }
      },
      canEdit: {
        serializedName: "canEdit",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const FeatureMaintenaceStatus: coreHttp.CompositeMapper = {
  serializedName: "FeatureMaintenaceStatus",
  type: {
    name: "Composite",
    className: "FeatureMaintenaceStatus",
    modelProperties: {
      featureName: {
        serializedName: "featureName",
        type: {
          name: "String"
        }
      },
      startDateUtc: {
        serializedName: "startDateUtc",
        type: {
          name: "DateTime"
        }
      },
      endDateUtc: {
        serializedName: "endDateUtc",
        type: {
          name: "DateTime"
        }
      },
      message: {
        serializedName: "message",
        type: {
          name: "String"
        }
      },
      bannerMessage: {
        serializedName: "bannerMessage",
        type: {
          name: "String"
        }
      },
      toastMessage: {
        serializedName: "toastMessage",
        type: {
          name: "String"
        }
      },
      isMaintenanceOnNow: {
        serializedName: "isMaintenanceOnNow",
        type: {
          name: "Boolean"
        }
      },
      disableDashboardCard: {
        serializedName: "disableDashboardCard",
        type: {
          name: "Boolean"
        }
      },
      showBannerOrToast: {
        serializedName: "showBannerOrToast",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const GetEncryptionAuthTokenApiResponse: coreHttp.CompositeMapper = {
  serializedName: "GetEncryptionAuthTokenApiResponse",
  type: {
    name: "Composite",
    className: "GetEncryptionAuthTokenApiResponse",
    modelProperties: {
      accessToken: {
        required: true,
        serializedName: "accessToken",
        type: {
          name: "String"
        }
      },
      baseUri: {
        required: true,
        serializedName: "baseUri",
        type: {
          name: "String"
        }
      },
      partnerNumber: {
        required: true,
        serializedName: "partnerNumber",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const RequiredFullAddress: coreHttp.CompositeMapper = {
  serializedName: "RequiredFullAddress",
  type: {
    name: "Composite",
    className: "RequiredFullAddress",
    modelProperties: {
      address1: {
        required: true,
        serializedName: "address1",
        type: {
          name: "String"
        }
      },
      address2: {
        serializedName: "address2",
        type: {
          name: "String"
        }
      },
      city: {
        serializedName: "city",
        type: {
          name: "String"
        }
      },
      state: {
        serializedName: "state",
        type: {
          name: "String"
        }
      },
      zipCode: {
        serializedName: "zipCode",
        type: {
          name: "String"
        }
      },
      countryCode: {
        serializedName: "countryCode",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const GetIdVerificationApiRequest: coreHttp.CompositeMapper = {
  serializedName: "GetIdVerificationApiRequest",
  type: {
    name: "Composite",
    className: "GetIdVerificationApiRequest",
    modelProperties: {
      isEncrypted: {
        serializedName: "isEncrypted",
        type: {
          name: "Boolean"
        }
      },
      ssndob: {
        required: true,
        serializedName: "ssndob",
        type: {
          name: "Composite",
          className: "RequiredSSNDOB"
        }
      },
      fullName: {
        required: true,
        serializedName: "fullName",
        type: {
          name: "Composite",
          className: "RequiredFullName"
        }
      },
      fullAddress: {
        required: true,
        serializedName: "fullAddress",
        type: {
          name: "Composite",
          className: "RequiredFullAddress"
        }
      },
      e2ESubscriberKey: {
        serializedName: "e2ESubscriberKey",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const QuestionData: coreHttp.CompositeMapper = {
  serializedName: "QuestionData",
  type: {
    name: "Composite",
    className: "QuestionData",
    modelProperties: {
      questionType: {
        serializedName: "questionType",
        type: {
          name: "String"
        }
      },
      questionNumber: {
        serializedName: "questionNumber",
        type: {
          name: "Number"
        }
      },
      question: {
        serializedName: "question",
        type: {
          name: "String"
        }
      },
      questionId: {
        serializedName: "questionId",
        type: {
          name: "Number"
        }
      },
      answerOption: {
        serializedName: "answerOption",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AnswerOption"
            }
          }
        }
      }
    }
  }
};

export const GetIdVerificationApiResponse: coreHttp.CompositeMapper = {
  serializedName: "GetIdVerificationApiResponse",
  type: {
    name: "Composite",
    className: "GetIdVerificationApiResponse",
    modelProperties: {
      applicantChallengeId: {
        serializedName: "applicantChallengeId",
        type: {
          name: "String"
        }
      },
      questionData: {
        serializedName: "questionData",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "QuestionData"
            }
          }
        }
      }
    }
  }
};

export const GetMonitoredDataTypesApiResponse: coreHttp.CompositeMapper = {
  serializedName: "GetMonitoredDataTypesApiResponse",
  type: {
    name: "Composite",
    className: "GetMonitoredDataTypesApiResponse",
    modelProperties: {
      monitoredDataTypes: {
        serializedName: "monitoredDataTypes",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "TelephoneNumber",
                "EmailAddress",
                "MedicalID",
                "Iban",
                "OtherCard",
                "DriverLicense",
                "Passport",
                "NationalId",
                "BankAccount",
                "CreditCard",
                "DebitCard",
                "SSN"
              ]
            }
          }
        }
      },
      unmonitoredDataTypes: {
        serializedName: "unmonitoredDataTypes",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "TelephoneNumber",
                "EmailAddress",
                "MedicalID",
                "Iban",
                "OtherCard",
                "DriverLicense",
                "Passport",
                "NationalId",
                "BankAccount",
                "CreditCard",
                "DebitCard",
                "SSN"
              ]
            }
          }
        }
      }
    }
  }
};

export const IPAddressLocation: coreHttp.CompositeMapper = {
  serializedName: "IPAddressLocation",
  type: {
    name: "Composite",
    className: "IPAddressLocation",
    modelProperties: {
      countryOrRegionISOCode: {
        serializedName: "countryOrRegionISOCode",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const ITPFamilyPermissionUpdate: coreHttp.CompositeMapper = {
  serializedName: "ITPFamilyPermissionUpdate",
  type: {
    name: "Composite",
    className: "ITPFamilyPermissionUpdate",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Enum",
          allowedValues: [
            "SEE_MY_ALERTS_AND_ADD_INFO",
            "ADD_MY_INFO",
            "NONE"
          ]
        }
      }
    }
  }
};

export const SimpleBreachEntity: coreHttp.CompositeMapper = {
  serializedName: "SimpleBreachEntity",
  type: {
    name: "Composite",
    className: "SimpleBreachEntity",
    modelProperties: {
      entityId: {
        serializedName: "entityId",
        type: {
          name: "String"
        }
      },
      breachType: {
        serializedName: "breachType",
        type: {
          name: "Enum",
          allowedValues: [
            "SocialSecurityNumber",
            "EmailAddress",
            "MedicalId",
            "CreditCard",
            "CreditCardCVN",
            "BankAccountNumber",
            "ResidentialAddress",
            "DriverLicenseNumber",
            "PassportNumber",
            "NationalId",
            "InternationalBankAccountNumber",
            "RetailCardNumber",
            "Name",
            "Addrstate",
            "BankRoute",
            "EbayPassword",
            "AddrCountry",
            "Password",
            "PhoneExt",
            "EbayUserId",
            "CardExpYear",
            "CreditCardPin",
            "BankingPin",
            "DriversLicenseState",
            "BankingPassword",
            "BankUserId",
            "AddrCity",
            "AddrZip",
            "CardCVN",
            "DateOfBirth",
            "MothersMaidenName",
            "CellPhone",
            "WorkPhone",
            "HomePhone",
            "PaypalPassword",
            "UserId",
            "BankName",
            "CardExpDay",
            "Addr2",
            "LastName",
            "BankPhone",
            "Cardtype",
            "Addr1",
            "MiddleName",
            "Phone",
            "PaypalUserId",
            "CardExpDate",
            "CardExpMonth",
            "CardName",
            "FirstName",
            "CardAddr",
            "MedicalProvider",
            "PassportIssueDate",
            "PassportExpDate",
            "PassportCountry",
            "NationalCountry",
            "SourceCategory",
            "CompromiseType",
            "BreachedSiteCountry",
            "BreachedSector",
            "BreachedSite",
            "PhishedKeyLoggedSite",
            "Hacker",
            "HackerGroup",
            "PasswordStatus",
            "HackingOperation",
            "Motivation"
          ]
        }
      },
      value: {
        serializedName: "value",
        type: {
          name: "String"
        }
      },
      state: {
        serializedName: "state",
        type: {
          name: "Enum",
          allowedValues: [
            "Remediated",
            "FalsePositive",
            "NotRelevant",
            "New"
          ]
        }
      },
      createdDate: {
        serializedName: "createdDate",
        type: {
          name: "DateTime"
        }
      },
      lastModifiedDate: {
        serializedName: "lastModifiedDate",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const IdentityMonitoringBreach: coreHttp.CompositeMapper = {
  serializedName: "IdentityMonitoringBreach",
  type: {
    name: "Composite",
    className: "IdentityMonitoringBreach",
    modelProperties: {
      itemClass: {
        serializedName: "itemClass",
        type: {
          name: "String"
        }
      },
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      createdDateTime: {
        serializedName: "createdDateTime",
        type: {
          name: "DateTime"
        }
      },
      lastModifiedDateTime: {
        serializedName: "lastModifiedDateTime",
        type: {
          name: "DateTime"
        }
      },
      systemExpirationDateTime: {
        serializedName: "systemExpirationDateTime",
        type: {
          name: "DateTime"
        }
      },
      secondaryKey: {
        serializedName: "secondaryKey",
        type: {
          name: "String"
        }
      },
      breachId: {
        serializedName: "breachId",
        type: {
          name: "String"
        }
      },
      isAlertIdsQueryable: {
        serializedName: "isAlertIdsQueryable",
        type: {
          name: "Boolean"
        }
      },
      alertIds: {
        serializedName: "alertIds",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      alertIdsType: {
        serializedName: "alertIdsType",
        type: {
          name: "String"
        }
      },
      isRecordIdsQueryable: {
        serializedName: "isRecordIdsQueryable",
        type: {
          name: "Boolean"
        }
      },
      recordIds: {
        serializedName: "recordIds",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      recordIdsType: {
        serializedName: "recordIdsType",
        type: {
          name: "String"
        }
      },
      isIdentityMonitoringBreachAlertIdQueryable: {
        serializedName: "isIdentityMonitoringBreachAlertIdQueryable",
        type: {
          name: "Boolean"
        }
      },
      identityMonitoringBreachAlertId: {
        serializedName: "identityMonitoringBreachAlertId",
        type: {
          name: "String"
        }
      },
      identityMonitoringBreachAlertIdType: {
        serializedName: "identityMonitoringBreachAlertIdType",
        type: {
          name: "String"
        }
      },
      isSiteQueryable: {
        serializedName: "isSiteQueryable",
        type: {
          name: "Boolean"
        }
      },
      site: {
        serializedName: "site",
        type: {
          name: "String"
        }
      },
      siteType: {
        serializedName: "siteType",
        type: {
          name: "String"
        }
      },
      isDateTimeOfBreachQueryable: {
        serializedName: "isDateTimeOfBreachQueryable",
        type: {
          name: "Boolean"
        }
      },
      dateTimeOfBreach: {
        serializedName: "dateTimeOfBreach",
        type: {
          name: "DateTime"
        }
      },
      dateTimeOfBreachType: {
        serializedName: "dateTimeOfBreachType",
        type: {
          name: "String"
        }
      },
      breachEntities: {
        serializedName: "breachEntities",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SimpleBreachEntity"
            }
          }
        }
      },
      compositeBreachEntities: {
        serializedName: "compositeBreachEntities",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CompositeBreachEntity"
            }
          }
        }
      },
      recommendations: {
        serializedName: "recommendations",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "IdentityMonitoringRecommendation"
            }
          }
        }
      },
      recommendationVersion: {
        serializedName: "recommendationVersion",
        type: {
          name: "Enum",
          allowedValues: [
            "None",
            "V1",
            "V2"
          ]
        }
      },
      isStateQueryable: {
        serializedName: "isStateQueryable",
        type: {
          name: "Boolean"
        }
      },
      state: {
        serializedName: "state",
        type: {
          name: "Enum",
          allowedValues: [
            "Remediated",
            "FalsePositive",
            "NotRelevant",
            "New"
          ]
        }
      },
      stateType: {
        serializedName: "stateType",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const ItmUserProfilePatchRequest: coreHttp.CompositeMapper = {
  serializedName: "ItmUserProfilePatchRequest",
  type: {
    name: "Composite",
    className: "ItmUserProfilePatchRequest",
    modelProperties: {
      showCreditScore: {
        serializedName: "showCreditScore",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const SubscriptionProductData: coreHttp.CompositeMapper = {
  serializedName: "SubscriptionProductData",
  type: {
    name: "Composite",
    className: "SubscriptionProductData",
    modelProperties: {
      endDate: {
        serializedName: "endDate",
        type: {
          name: "DateTime"
        }
      },
      autoRenew: {
        serializedName: "autoRenew",
        type: {
          name: "Boolean"
        }
      },
      isTrial: {
        serializedName: "isTrial",
        type: {
          name: "Boolean"
        }
      },
      isOwner: {
        serializedName: "isOwner",
        type: {
          name: "Boolean"
        }
      },
      isFamily: {
        serializedName: "isFamily",
        type: {
          name: "Boolean"
        }
      },
      entitlementValidityReasonCode: {
        serializedName: "entitlementValidityReasonCode",
        type: {
          name: "String"
        }
      },
      skuType: {
        serializedName: "skuType",
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const License: coreHttp.CompositeMapper = {
  serializedName: "License",
  type: {
    name: "Composite",
    className: "License",
    modelProperties: {
      activeSubscriptionProducts: {
        serializedName: "activeSubscriptionProducts",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SubscriptionProductData"
            }
          }
        }
      },
      activeSubscriptionProduct: {
        serializedName: "activeSubscriptionProduct",
        type: {
          name: "Composite",
          className: "SubscriptionProductData"
        }
      },
      expiredSubscriptionProduct: {
        serializedName: "expiredSubscriptionProduct",
        type: {
          name: "Composite",
          className: "SubscriptionProductData"
        }
      },
      isLicenseRequired: {
        serializedName: "isLicenseRequired",
        type: {
          name: "Boolean"
        }
      },
      perpetualCategories: {
        serializedName: "perpetualCategories",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      userId: {
        serializedName: "userId",
        type: {
          name: "String"
        }
      },
      isSubscriptionActive: {
        serializedName: "isSubscriptionActive",
        type: {
          name: "Boolean"
        }
      },
      retrievalDateTime: {
        serializedName: "retrievalDateTime",
        type: {
          name: "DateTime"
        }
      },
      skuType: {
        serializedName: "skuType",
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const MaintenanceStatus: coreHttp.CompositeMapper = {
  serializedName: "MaintenanceStatus",
  type: {
    name: "Composite",
    className: "MaintenanceStatus",
    modelProperties: {
      statuses: {
        readOnly: true,
        serializedName: "statuses",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "FeatureMaintenaceStatus"
            }
          }
        }
      }
    }
  }
};

export const MemberUserIdRequest: coreHttp.CompositeMapper = {
  serializedName: "MemberUserIdRequest",
  type: {
    name: "Composite",
    className: "MemberUserIdRequest",
    modelProperties: {
      memberUserId: {
        serializedName: "memberUserId",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const MemberUserIdWithPrimaryDataRequest: coreHttp.CompositeMapper = {
  serializedName: "MemberUserIdWithPrimaryDataRequest",
  type: {
    name: "Composite",
    className: "MemberUserIdWithPrimaryDataRequest",
    modelProperties: {
      memberUserId: {
        required: true,
        serializedName: "memberUserId",
        type: {
          name: "String"
        }
      },
      dateOfBirth: {
        required: true,
        serializedName: "dateOfBirth",
        type: {
          name: "DateTime"
        }
      },
      fullName: {
        required: true,
        serializedName: "fullName",
        type: {
          name: "Composite",
          className: "RequiredFullName"
        }
      }
    }
  }
};

export const OneTimeCyberAgentScanRequest: coreHttp.CompositeMapper = {
  serializedName: "OneTimeCyberAgentScanRequest",
  type: {
    name: "Composite",
    className: "OneTimeCyberAgentScanRequest",
    modelProperties: {
      emailAddress: {
        required: true,
        serializedName: "emailAddress",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const OneTimeCyberAgentScanStatusData: coreHttp.CompositeMapper = {
  serializedName: "OneTimeCyberAgentScanStatusData",
  type: {
    name: "Composite",
    className: "OneTimeCyberAgentScanStatusData",
    modelProperties: {
      isRegistrationInGeoAvailable: {
        serializedName: "isRegistrationInGeoAvailable",
        type: {
          name: "Boolean"
        }
      },
      isRegistrationAvailable: {
        serializedName: "isRegistrationAvailable",
        type: {
          name: "Boolean"
        }
      },
      isScanRetrievalAvailable: {
        serializedName: "isScanRetrievalAvailable",
        type: {
          name: "Boolean"
        }
      },
      scanStatus: {
        serializedName: "scanStatus",
        type: {
          name: "Enum",
          allowedValues: [
            "NotStarted",
            "Active",
            "Expired",
            "ExpiredPreCutoff",
            "Upgraded"
          ]
        }
      },
      scanRequestedDateTime: {
        serializedName: "scanRequestedDateTime",
        type: {
          name: "DateTime"
        }
      },
      scanExpirationDateTime: {
        serializedName: "scanExpirationDateTime",
        type: {
          name: "DateTime"
        }
      },
      retrievalDateTime: {
        serializedName: "retrievalDateTime",
        type: {
          name: "DateTime"
        }
      },
      scannedEmailAddress: {
        serializedName: "scannedEmailAddress",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const PatchBreachesRequest: coreHttp.CompositeMapper = {
  serializedName: "PatchBreachesRequest",
  type: {
    name: "Composite",
    className: "PatchBreachesRequest",
    modelProperties: {
      breachIds: {
        required: true,
        serializedName: "breachIds",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      state: {
        required: true,
        serializedName: "state",
        type: {
          name: "Enum",
          allowedValues: [
            "Remediated",
            "FalsePositive",
            "NotRelevant",
            "New"
          ]
        }
      }
    }
  }
};

export const PatchRecommendationRequest: coreHttp.CompositeMapper = {
  serializedName: "PatchRecommendationRequest",
  type: {
    name: "Composite",
    className: "PatchRecommendationRequest",
    modelProperties: {
      isDismissed: {
        required: true,
        serializedName: "isDismissed",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const PendingAlert: coreHttp.CompositeMapper = {
  serializedName: "PendingAlert",
  type: {
    name: "Composite",
    className: "PendingAlert",
    modelProperties: {
      eventType: {
        required: true,
        serializedName: "eventType",
        type: {
          name: "Enum",
          allowedValues: [
            "DeviceAdded",
            "DeviceRemoved",
            "DeviceSignedOut",
            "DeviceThreat",
            "DeviceRtpOff",
            "DeviceRtpOn",
            "PhishingLink",
            "AntiphishingOff",
            "AntiphishingOn",
            "DeviceScanCompleted",
            "ITPBreachCritical",
            "ITPBreachHigh",
            "ITPBreachMedium",
            "ITPBreachInformational",
            "ITPDelegationRequest",
            "ITPSharingRequest",
            "DeviceRtpSetting",
            "AntiphishingSetting",
            "SecureConnectionConsumerVpnMonthlyQuota",
            "ITMCreditEventHigh",
            "ITMCreditEventNormal",
            "AutoSampleSubmissionSetting",
            "DeviceThreatDetected",
            "DeviceThreatResolved"
          ]
        }
      },
      detectionId: {
        serializedName: "detectionId",
        type: {
          name: "String"
        }
      },
      deviceId: {
        serializedName: "deviceId",
        type: {
          name: "String"
        }
      },
      eventDateTime: {
        required: true,
        serializedName: "eventDateTime",
        type: {
          name: "DateTime"
        }
      },
      isRead: {
        serializedName: "isRead",
        type: {
          name: "Boolean"
        }
      },
      isDismissed: {
        serializedName: "isDismissed",
        type: {
          name: "Boolean"
        }
      },
      isDismissedModifiedDateTime: {
        serializedName: "isDismissedModifiedDateTime",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const PhoneGenerateCodeRequest: coreHttp.CompositeMapper = {
  serializedName: "PhoneGenerateCodeRequest",
  type: {
    name: "Composite",
    className: "PhoneGenerateCodeRequest",
    modelProperties: {
      countryCode: {
        required: true,
        serializedName: "countryCode",
        type: {
          name: "String"
        }
      },
      phoneNumber: {
        required: true,
        serializedName: "phoneNumber",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const PhoneVerificationCodeRequest: coreHttp.CompositeMapper = {
  serializedName: "PhoneVerificationCodeRequest",
  type: {
    name: "Composite",
    className: "PhoneVerificationCodeRequest",
    modelProperties: {
      countryCode: {
        required: true,
        serializedName: "countryCode",
        type: {
          name: "String"
        }
      },
      phoneNumber: {
        required: true,
        serializedName: "phoneNumber",
        type: {
          name: "String"
        }
      },
      securityCode: {
        required: true,
        serializedName: "securityCode",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const ProtectionSettingParameters: coreHttp.CompositeMapper = {
  serializedName: "ProtectionSettingParameters",
  type: {
    name: "Composite",
    className: "ProtectionSettingParameters",
    modelProperties: {
      protectionSettingType: {
        required: true,
        serializedName: "protectionSettingType",
        type: {
          name: "Enum",
          allowedValues: [
            "RealTimeProtectionSetting",
            "AntiPhishingSetting",
            "AutoSampleSubmissionSetting"
          ]
        }
      }
    }
  }
};

export const PublicFeatureFlags: coreHttp.CompositeMapper = {
  serializedName: "PublicFeatureFlags",
  type: {
    name: "Composite",
    className: "PublicFeatureFlags",
    modelProperties: {
      appLauncherPage: {
        serializedName: "appLauncherPage",
        type: {
          name: "Boolean"
        }
      },
      familySetting: {
        serializedName: "familySetting",
        type: {
          name: "Boolean"
        }
      },
      privacySetting: {
        serializedName: "privacySetting",
        type: {
          name: "Boolean"
        }
      },
      notificationSetting: {
        serializedName: "notificationSetting",
        type: {
          name: "Boolean"
        }
      },
      securityScore: {
        serializedName: "securityScore",
        type: {
          name: "Boolean"
        }
      },
      sandbox: {
        serializedName: "sandbox",
        type: {
          name: "Boolean"
        }
      },
      deviceDetailsPage: {
        serializedName: "deviceDetailsPage",
        type: {
          name: "Boolean"
        }
      },
      identityMonitoring: {
        serializedName: "identityMonitoring",
        type: {
          name: "Boolean"
        }
      },
      identityMonitoringE2EEncryption: {
        serializedName: "identityMonitoringE2EEncryption",
        type: {
          name: "Boolean"
        }
      },
      identityMonitoringE2EEncryptionOnMac: {
        serializedName: "identityMonitoringE2EEncryptionOnMac",
        type: {
          name: "Boolean"
        }
      },
      identityTheftMonitoringFamilyApi: {
        serializedName: "identityTheftMonitoringFamilyApi",
        type: {
          name: "Boolean"
        }
      },
      removeITPSubscription: {
        serializedName: "removeITPSubscription",
        type: {
          name: "Boolean"
        }
      },
      addSSN: {
        serializedName: "addSSN",
        type: {
          name: "Boolean"
        }
      },
      deviceAlertWebView: {
        serializedName: "deviceAlertWebView",
        type: {
          name: "Boolean"
        }
      },
      alertsPageEnabled: {
        serializedName: "alertsPageEnabled",
        type: {
          name: "Boolean"
        }
      },
      useEnglishLocaleOnly: {
        serializedName: "useEnglishLocaleOnly",
        type: {
          name: "Boolean"
        }
      },
      licenseRequired: {
        serializedName: "licenseRequired",
        type: {
          name: "Boolean"
        }
      },
      wellKnownChangePassword: {
        serializedName: "wellKnownChangePassword",
        type: {
          name: "Boolean"
        }
      },
      enableDime: {
        serializedName: "enableDime",
        type: {
          name: "Boolean"
        }
      },
      enableDimeMsalBroker: {
        serializedName: "enableDimeMsalBroker",
        type: {
          name: "Boolean"
        }
      },
      groupItmBreachesAlerts: {
        serializedName: "groupItmBreachesAlerts",
        type: {
          name: "Boolean"
        }
      },
      breachBulkAction: {
        serializedName: "breachBulkAction",
        type: {
          name: "Boolean"
        }
      },
      useBreachBulkUpdateAPI: {
        serializedName: "useBreachBulkUpdateAPI",
        type: {
          name: "Boolean"
        }
      },
      webPaywallShowTrial: {
        serializedName: "webPaywallShowTrial",
        type: {
          name: "Boolean"
        }
      },
      creditMonitoringUIEnabled: {
        serializedName: "creditMonitoringUIEnabled",
        type: {
          name: "Boolean"
        }
      },
      creditMonitoringFamilyUIEnabled: {
        serializedName: "creditMonitoringFamilyUIEnabled",
        type: {
          name: "Boolean"
        }
      },
      showMsaImportButton: {
        serializedName: "showMsaImportButton",
        type: {
          name: "Boolean"
        }
      },
      creditMonitoringApi: {
        serializedName: "creditMonitoringApi",
        type: {
          name: "Boolean"
        }
      },
      creditMonitoringRecommendations: {
        serializedName: "creditMonitoringRecommendations",
        type: {
          name: "Boolean"
        }
      },
      secureConnectionApi: {
        serializedName: "secureConnectionApi",
        type: {
          name: "Boolean"
        }
      },
      useCodeInputV2: {
        serializedName: "useCodeInputV2",
        type: {
          name: "Boolean"
        }
      },
      enableClarity: {
        serializedName: "enableClarity",
        type: {
          name: "Boolean"
        }
      },
      clarityProjectId: {
        serializedName: "clarityProjectId",
        type: {
          name: "String"
        }
      },
      showRewardActivities: {
        serializedName: "showRewardActivities",
        type: {
          name: "Boolean"
        }
      },
      upsellRewardsWelcomeVariant: {
        serializedName: "upsellRewardsWelcomeVariant",
        type: {
          name: "String"
        }
      },
      oneTimeCyberAgentScanApi: {
        serializedName: "oneTimeCyberAgentScanApi",
        type: {
          name: "Boolean"
        }
      },
      unauthOneTimeCyberAgentScanApi: {
        serializedName: "unauthOneTimeCyberAgentScanApi",
        type: {
          name: "Boolean"
        }
      },
      showUnmonitoredTypes: {
        serializedName: "showUnmonitoredTypes",
        type: {
          name: "Boolean"
        }
      },
      unknownBreachOptimizations: {
        serializedName: "unknownBreachOptimizations",
        type: {
          name: "Boolean"
        }
      },
      useDedupedRecommendations: {
        serializedName: "useDedupedRecommendations",
        type: {
          name: "Boolean"
        }
      },
      creditScoreVisibility: {
        serializedName: "creditScoreVisibility",
        type: {
          name: "Boolean"
        }
      },
      redirectPaywallToOTS: {
        serializedName: "redirectPaywallToOTS",
        type: {
          name: "Boolean"
        }
      },
      copilotApi: {
        serializedName: "copilotApi",
        type: {
          name: "Boolean"
        }
      },
      enableAsyncBreachScan: {
        serializedName: "enableAsyncBreachScan",
        type: {
          name: "Boolean"
        }
      },
      itmDeleteWithHash: {
        serializedName: "itmDeleteWithHash",
        type: {
          name: "Boolean"
        }
      },
      cmAuthCheckWeb: {
        serializedName: "cmAuthCheckWeb",
        type: {
          name: "Boolean"
        }
      },
      cmAuthCheckWindows: {
        serializedName: "cmAuthCheckWindows",
        type: {
          name: "Boolean"
        }
      },
      cmAuthCheckMacOs: {
        serializedName: "cmAuthCheckMacOs",
        type: {
          name: "Boolean"
        }
      },
      cmAuthCheckIOS: {
        serializedName: "cmAuthCheckIOS",
        type: {
          name: "Boolean"
        }
      },
      cmAuthCheckAndroid: {
        serializedName: "cmAuthCheckAndroid",
        type: {
          name: "Boolean"
        }
      },
      themeSwitchingWeb: {
        serializedName: "themeSwitchingWeb",
        type: {
          name: "Boolean"
        }
      },
      themeSwitchingWebView: {
        serializedName: "themeSwitchingWebView",
        type: {
          name: "Boolean"
        }
      },
      cmApiProtection: {
        serializedName: "cmApiProtection",
        type: {
          name: "Boolean"
        }
      },
      trustedNetworkApi: {
        serializedName: "trustedNetworkApi",
        type: {
          name: "Boolean"
        }
      },
      enableDiagnosticsPage: {
        serializedName: "enableDiagnosticsPage",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const PublicPreviewSettings: coreHttp.CompositeMapper = {
  serializedName: "PublicPreviewSettings",
  type: {
    name: "Composite",
    className: "PublicPreviewSettings",
    modelProperties: {
      previewEndDate: {
        serializedName: "previewEndDate",
        type: {
          name: "DateTime"
        }
      },
      startAlertDate: {
        serializedName: "startAlertDate",
        type: {
          name: "DateTime"
        }
      },
      nextAlertDate: {
        serializedName: "nextAlertDate",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const PushNotification: coreHttp.CompositeMapper = {
  serializedName: "PushNotification",
  type: {
    name: "Composite",
    className: "PushNotification",
    modelProperties: {
      title: {
        required: true,
        serializedName: "title",
        type: {
          name: "String"
        }
      },
      subtitle: {
        required: true,
        serializedName: "subtitle",
        type: {
          name: "String"
        }
      },
      badgeCount: {
        serializedName: "badgeCount",
        type: {
          name: "Number"
        }
      },
      alertIds: {
        required: true,
        serializedName: "alertIds",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      type: {
        required: true,
        serializedName: "type",
        type: {
          name: "Enum",
          allowedValues: [
            "Raw",
            "Toast"
          ]
        }
      },
      eventGroupType: {
        serializedName: "eventGroupType",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "UserRecovery"
          ]
        }
      }
    }
  }
};

export const RecommendationState: coreHttp.CompositeMapper = {
  serializedName: "RecommendationState",
  type: {
    name: "Composite",
    className: "RecommendationState",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      isDismissed: {
        serializedName: "isDismissed",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const RegisterCreditMonitoringSubscriberApiResponse: coreHttp.CompositeMapper = {
  serializedName: "RegisterCreditMonitoringSubscriberApiResponse",
  type: {
    name: "Composite",
    className: "RegisterCreditMonitoringSubscriberApiResponse",
    modelProperties: {
      subscriberNumber: {
        serializedName: "subscriberNumber",
        type: {
          name: "String"
        }
      },
      creditMonitoringOnboardingDateTime: {
        readOnly: true,
        serializedName: "creditMonitoringOnboardingDateTime",
        type: {
          name: "DateTime"
        }
      },
      creditScore: {
        serializedName: "creditScore",
        type: {
          name: "String"
        }
      },
      creditScoreRating: {
        serializedName: "creditScoreRating",
        type: {
          name: "String"
        }
      },
      formattedCreditScoreWithRating: {
        serializedName: "formattedCreditScoreWithRating",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const RegisterSubscriberApiResponse: coreHttp.CompositeMapper = {
  serializedName: "RegisterSubscriberApiResponse",
  type: {
    name: "Composite",
    className: "RegisterSubscriberApiResponse",
    modelProperties: {
      subscriberNumber: {
        serializedName: "subscriberNumber",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const RegisterSubscriberWithPrimaryDataRequest: coreHttp.CompositeMapper = {
  serializedName: "RegisterSubscriberWithPrimaryDataRequest",
  type: {
    name: "Composite",
    className: "RegisterSubscriberWithPrimaryDataRequest",
    modelProperties: {
      emailAddress: {
        required: true,
        serializedName: "emailAddress",
        type: {
          name: "String"
        }
      },
      dateOfBirth: {
        required: true,
        serializedName: "dateOfBirth",
        type: {
          name: "DateTime"
        }
      },
      fullName: {
        required: true,
        serializedName: "fullName",
        type: {
          name: "Composite",
          className: "RequiredFullName"
        }
      }
    }
  }
};

export const ResolveRecommendationRequest: coreHttp.CompositeMapper = {
  serializedName: "ResolveRecommendationRequest",
  type: {
    name: "Composite",
    className: "ResolveRecommendationRequest",
    modelProperties: {
      isCompleted: {
        required: true,
        serializedName: "isCompleted",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const ScanRequest: coreHttp.CompositeMapper = {
  serializedName: "ScanRequest",
  type: {
    name: "Composite",
    className: "ScanRequest",
    modelProperties: {
      fullScan: {
        required: true,
        serializedName: "fullScan",
        type: {
          name: "Boolean"
        }
      },
      entityValue: {
        serializedName: "entityValue",
        type: {
          name: "String"
        }
      },
      breachedType: {
        serializedName: "breachedType",
        type: {
          name: "Enum",
          allowedValues: [
            "SocialSecurityNumber",
            "EmailAddress",
            "MedicalId",
            "CreditCard",
            "CreditCardCVN",
            "BankAccountNumber",
            "ResidentialAddress",
            "DriverLicenseNumber",
            "PassportNumber",
            "NationalId",
            "InternationalBankAccountNumber",
            "RetailCardNumber",
            "Name",
            "Addrstate",
            "BankRoute",
            "EbayPassword",
            "AddrCountry",
            "Password",
            "PhoneExt",
            "EbayUserId",
            "CardExpYear",
            "CreditCardPin",
            "BankingPin",
            "DriversLicenseState",
            "BankingPassword",
            "BankUserId",
            "AddrCity",
            "AddrZip",
            "CardCVN",
            "DateOfBirth",
            "MothersMaidenName",
            "CellPhone",
            "WorkPhone",
            "HomePhone",
            "PaypalPassword",
            "UserId",
            "BankName",
            "CardExpDay",
            "Addr2",
            "LastName",
            "BankPhone",
            "Cardtype",
            "Addr1",
            "MiddleName",
            "Phone",
            "PaypalUserId",
            "CardExpDate",
            "CardExpMonth",
            "CardName",
            "FirstName",
            "CardAddr",
            "MedicalProvider",
            "PassportIssueDate",
            "PassportExpDate",
            "PassportCountry",
            "NationalCountry",
            "SourceCategory",
            "CompromiseType",
            "BreachedSiteCountry",
            "BreachedSector",
            "BreachedSite",
            "PhishedKeyLoggedSite",
            "Hacker",
            "HackerGroup",
            "PasswordStatus",
            "HackingOperation",
            "Motivation"
          ]
        }
      }
    }
  }
};

export const SecureConnectionCertificateData: coreHttp.CompositeMapper = {
  serializedName: "SecureConnectionCertificateData",
  type: {
    name: "Composite",
    className: "SecureConnectionCertificateData",
    modelProperties: {
      certificateHash: {
        serializedName: "certificateHash",
        type: {
          name: "String"
        }
      },
      isProfile: {
        serializedName: "isProfile",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const SecureConnectionEndpoint: coreHttp.CompositeMapper = {
  serializedName: "SecureConnectionEndpoint",
  type: {
    name: "Composite",
    className: "SecureConnectionEndpoint",
    modelProperties: {
      vpnGwAddress: {
        serializedName: "vpnGwAddress",
        type: {
          name: "String"
        }
      },
      vpnGwServerName: {
        serializedName: "vpnGwServerName",
        type: {
          name: "String"
        }
      },
      vpnGwPort: {
        serializedName: "vpnGwPort",
        type: {
          name: "String"
        }
      },
      vpnDnsAddress: {
        serializedName: "vpnDnsAddress",
        type: {
          name: "String"
        }
      },
      ring: {
        serializedName: "ring",
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const SecureConnectionPlatformSetting: coreHttp.CompositeMapper = {
  serializedName: "SecureConnectionPlatformSetting",
  type: {
    name: "Composite",
    className: "SecureConnectionPlatformSetting",
    modelProperties: {
      certificatesData: {
        serializedName: "certificatesData",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SecureConnectionCertificateData"
            }
          }
        }
      },
      endpoints: {
        serializedName: "endpoints",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SecureConnectionEndpoint"
            }
          }
        }
      },
      geoEndpoints: {
        serializedName: "geoEndpoints",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "Sequence",
              element: {
                type: {
                  name: "Composite",
                  className: "SecureConnectionEndpoint"
                }
              }
            }
          }
        }
      },
      enableSplitTunnelling: {
        serializedName: "enableSplitTunnelling",
        type: {
          name: "Boolean"
        }
      },
      excludedDomainList: {
        serializedName: "excludedDomainList",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      }
    }
  }
};

export const SecureConnectionVPNServerSettings: coreHttp.CompositeMapper = {
  serializedName: "SecureConnectionVPNServerSettings",
  type: {
    name: "Composite",
    className: "SecureConnectionVPNServerSettings",
    modelProperties: {
      maxBandwidthInGB: {
        serializedName: "maxBandwidthInGB",
        type: {
          name: "Number"
        }
      },
      postFUPSpeedInKBPS: {
        serializedName: "postFUPSpeedInKBPS",
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const SecureConnectionFlightSettings: coreHttp.CompositeMapper = {
  serializedName: "SecureConnectionFlightSettings",
  type: {
    name: "Composite",
    className: "SecureConnectionFlightSettings",
    modelProperties: {
      platformSettings: {
        serializedName: "platformSettings",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "Composite",
              className: "SecureConnectionPlatformSetting"
            }
          }
        }
      },
      vpnServerSettings: {
        serializedName: "vpnServerSettings",
        type: {
          name: "Composite",
          className: "SecureConnectionVPNServerSettings"
        }
      }
    }
  }
};

export const Setting: coreHttp.CompositeMapper = {
  serializedName: "Setting",
  type: {
    name: "Composite",
    className: "Setting",
    modelProperties: {
      itemClass: {
        serializedName: "itemClass",
        type: {
          name: "String"
        }
      },
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      createdDateTime: {
        serializedName: "createdDateTime",
        type: {
          name: "DateTime"
        }
      },
      lastModifiedDateTime: {
        serializedName: "lastModifiedDateTime",
        type: {
          name: "DateTime"
        }
      },
      systemExpirationDateTime: {
        serializedName: "systemExpirationDateTime",
        type: {
          name: "DateTime"
        }
      },
      secondaryKey: {
        serializedName: "secondaryKey",
        type: {
          name: "String"
        }
      },
      key: {
        serializedName: "key",
        type: {
          name: "String"
        }
      },
      value: {
        serializedName: "value",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const SettingAlertHistoryItem: coreHttp.CompositeMapper = {
  serializedName: "SettingAlertHistoryItem",
  type: {
    name: "Composite",
    className: "SettingAlertHistoryItem",
    modelProperties: {
      status: {
        serializedName: "status",
        type: {
          name: "Enum",
          allowedValues: [
            "NotApplicable",
            "On",
            "Off"
          ]
        }
      },
      statusDescription: {
        serializedName: "statusDescription",
        type: {
          name: "String"
        }
      },
      isManagedByAdministrator: {
        serializedName: "isManagedByAdministrator",
        type: {
          name: "Boolean"
        }
      },
      eventDateTime: {
        serializedName: "eventDateTime",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const SettingDetails: coreHttp.CompositeMapper = {
  serializedName: "SettingDetails",
  type: {
    name: "Composite",
    className: "SettingDetails",
    modelProperties: {
      alertId: {
        serializedName: "alertId",
        type: {
          name: "String"
        }
      },
      alertCategory: {
        serializedName: "alertCategory",
        type: {
          name: "Enum",
          allowedValues: [
            "Info",
            "Threat"
          ]
        }
      },
      protectionSettingType: {
        serializedName: "protectionSettingType",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "RealTimeProtectionSetting",
            "AntiPhishingSetting",
            "AdvancedThreatProtectionSetting",
            "AutoSampleSubmissionSetting",
            "AutoScanSetting",
            "ScreenLockSetting",
            "VpnSetting"
          ]
        }
      },
      deviceName: {
        serializedName: "deviceName",
        type: {
          name: "String"
        }
      },
      devicePlatform: {
        serializedName: "devicePlatform",
        type: {
          name: "Enum",
          allowedValues: [
            "Windows",
            "Android",
            "iOS",
            "macOS",
            "Unknown"
          ]
        }
      },
      history: {
        serializedName: "history",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SettingAlertHistoryItem"
            }
          }
        }
      },
      actions: {
        serializedName: "actions",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "None",
                "Dismiss",
                "SaveForLater",
                "TakeAction",
                "SeeDetails"
              ]
            }
          }
        }
      }
    }
  }
};

export const SubmitIDVerificationDataApiQuestionData: coreHttp.CompositeMapper = {
  serializedName: "SubmitIDVerificationDataApiQuestionData",
  type: {
    name: "Composite",
    className: "SubmitIDVerificationDataApiQuestionData",
    modelProperties: {
      questionNumber: {
        required: true,
        serializedName: "questionNumber",
        type: {
          name: "String"
        }
      },
      answerNumber: {
        required: true,
        serializedName: "answerNumber",
        type: {
          name: "String"
        }
      },
      questionId: {
        required: true,
        serializedName: "questionId",
        type: {
          name: "String"
        }
      },
      answerChoiceId: {
        required: true,
        serializedName: "answerChoiceId",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const SubmitIdVerificationDataApiRequest: coreHttp.CompositeMapper = {
  serializedName: "SubmitIdVerificationDataApiRequest",
  type: {
    name: "Composite",
    className: "SubmitIdVerificationDataApiRequest",
    modelProperties: {
      applicantChallengeId: {
        required: true,
        serializedName: "applicantChallengeId",
        type: {
          name: "String"
        }
      },
      questions: {
        required: true,
        serializedName: "questions",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SubmitIDVerificationDataApiQuestionData"
            }
          }
        }
      }
    }
  }
};

export const SubmitIdVerificationDataApiResponse: coreHttp.CompositeMapper = {
  serializedName: "SubmitIdVerificationDataApiResponse",
  type: {
    name: "Composite",
    className: "SubmitIdVerificationDataApiResponse",
    modelProperties: {
      moreAuthenticationRequired: {
        serializedName: "moreAuthenticationRequired",
        type: {
          name: "String"
        }
      },
      questionData: {
        serializedName: "questionData",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "QuestionData"
            }
          }
        }
      }
    }
  }
};

export const SubscriberOnboardingStatusApiResponse: coreHttp.CompositeMapper = {
  serializedName: "SubscriberOnboardingStatusApiResponse",
  type: {
    name: "Composite",
    className: "SubscriberOnboardingStatusApiResponse",
    modelProperties: {
      subscriberNumber: {
        serializedName: "subscriberNumber",
        type: {
          name: "String"
        }
      },
      status: {
        readOnly: true,
        serializedName: "status",
        type: {
          name: "Enum",
          allowedValues: [
            "NotStarted",
            "Completed"
          ]
        }
      },
      creditMonitoringOnboardingStatus: {
        readOnly: true,
        serializedName: "creditMonitoringOnboardingStatus",
        type: {
          name: "Enum",
          allowedValues: [
            "NotStarted",
            "SSNFailed",
            "SSNRegistered",
            "Completed"
          ]
        }
      }
    }
  }
};

export const SubscriberOnboardingSummaryApiResponse: coreHttp.CompositeMapper = {
  serializedName: "SubscriberOnboardingSummaryApiResponse",
  type: {
    name: "Composite",
    className: "SubscriberOnboardingSummaryApiResponse",
    modelProperties: {
      itmOnboardingStatus: {
        readOnly: true,
        serializedName: "itmOnboardingStatus",
        type: {
          name: "Enum",
          allowedValues: [
            "NotStarted",
            "Completed"
          ]
        }
      },
      monitoredAssetCount: {
        serializedName: "monitoredAssetCount",
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const SubscriberProfileApiResponse: coreHttp.CompositeMapper = {
  serializedName: "SubscriberProfileApiResponse",
  type: {
    name: "Composite",
    className: "SubscriberProfileApiResponse",
    modelProperties: {
      displayName: {
        serializedName: "displayName",
        type: {
          name: "String"
        }
      },
      ssnAvailable: {
        serializedName: "ssnAvailable",
        type: {
          name: "Boolean"
        }
      },
      typeNumber: {
        serializedName: "typeNumber",
        type: {
          name: "String"
        }
      },
      fullName: {
        serializedName: "fullName",
        type: {
          name: "Composite",
          className: "FullName"
        }
      },
      fullAddress: {
        serializedName: "fullAddress",
        type: {
          name: "Composite",
          className: "FullAddress"
        }
      },
      emailAddress: {
        serializedName: "emailAddress",
        type: {
          name: "String"
        }
      },
      telephone: {
        serializedName: "telephone",
        type: {
          name: "String"
        }
      },
      webActive: {
        serializedName: "webActive",
        type: {
          name: "String"
        }
      },
      active: {
        serializedName: "active",
        type: {
          name: "Boolean"
        }
      },
      disclosureDateTime: {
        serializedName: "disclosureDateTime",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const TargetedGeoFencingData: coreHttp.CompositeMapper = {
  serializedName: "TargetedGeoFencingData",
  type: {
    name: "Composite",
    className: "TargetedGeoFencingData",
    modelProperties: {
      showITPOnboarding: {
        serializedName: "showITPOnboarding",
        type: {
          name: "Boolean"
        }
      },
      showSecureConnectionOnboarding: {
        serializedName: "showSecureConnectionOnboarding",
        type: {
          name: "Boolean"
        }
      },
      countryOrRegionCode: {
        serializedName: "countryOrRegionCode",
        type: {
          name: "String"
        }
      },
      allowPortalAccess: {
        serializedName: "allowPortalAccess",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const TestITPPushNotification: coreHttp.CompositeMapper = {
  serializedName: "TestITPPushNotification",
  type: {
    name: "Composite",
    className: "TestITPPushNotification",
    modelProperties: {
      breachIds: {
        serializedName: "breachIds",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      alertCount: {
        serializedName: "alertCount",
        type: {
          name: "Number"
        }
      },
      pushNotificationType: {
        serializedName: "pushNotificationType",
        type: {
          name: "Enum",
          allowedValues: [
            "Raw",
            "Toast"
          ]
        }
      }
    }
  }
};

export const ThreatAlertHistoryItem: coreHttp.CompositeMapper = {
  serializedName: "ThreatAlertHistoryItem",
  type: {
    name: "Composite",
    className: "ThreatAlertHistoryItem",
    modelProperties: {
      status: {
        serializedName: "status",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "Abandoned",
            "AllowFailed",
            "Allowed",
            "BlockFailed",
            "Blocked",
            "CleanFailed",
            "Cleaned",
            "Detected",
            "Quarantined",
            "RemoveFailed",
            "Removed",
            "RemovedFromQuarantine",
            "RestoredFromQuarantine"
          ]
        }
      },
      statusDescription: {
        serializedName: "statusDescription",
        type: {
          name: "String"
        }
      },
      eventDateTime: {
        serializedName: "eventDateTime",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const ThreatDetails: coreHttp.CompositeMapper = {
  serializedName: "ThreatDetails",
  type: {
    name: "Composite",
    className: "ThreatDetails",
    modelProperties: {
      alertId: {
        serializedName: "alertId",
        type: {
          name: "String"
        }
      },
      threatType: {
        serializedName: "threatType",
        type: {
          name: "Enum",
          allowedValues: [
            "App",
            "File"
          ]
        }
      },
      name: {
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      deviceName: {
        serializedName: "deviceName",
        type: {
          name: "String"
        }
      },
      devicePlatform: {
        serializedName: "devicePlatform",
        type: {
          name: "Enum",
          allowedValues: [
            "Windows",
            "Android",
            "iOS",
            "macOS",
            "Unknown"
          ]
        }
      },
      category: {
        serializedName: "category",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "Adware",
            "AolExploiter",
            "ArchiveBomb",
            "Backdoor",
            "Behavior",
            "BrowserModifier",
            "BrowserPlugin",
            "Cookie",
            "Dialer",
            "EmailFlooder",
            "Exploit",
            "FileSharingProgram",
            "HipsRule",
            "HostileActiveXControl",
            "IcqExploit",
            "JokeProgram",
            "KeyLogger",
            "Known",
            "Malware",
            "MalwareCreationTool",
            "MonitoringSoftware",
            "Nuker",
            "PasswordStealer",
            "Policy",
            "PotentiallyUnwantedSoftware",
            "Ransomware",
            "RemoteAccessTrojan",
            "RemoteControlSoftware",
            "SSP",
            "SecurityDisabler",
            "SettingsModifier",
            "SoftwareBundler",
            "Spyware",
            "StealthNotifier",
            "Toolbar",
            "Trojan",
            "TrojanDenialOfService",
            "TrojanDownloader",
            "TrojanDropper",
            "TrojanFtp",
            "TrojanMassMailer",
            "TrojanMonitoringSoftware",
            "TrojanProxyServer",
            "TrojanTelnet",
            "Virus",
            "Vulnerability",
            "Worm"
          ]
        }
      },
      alertCategory: {
        serializedName: "alertCategory",
        type: {
          name: "Enum",
          allowedValues: [
            "Info",
            "Threat"
          ]
        }
      },
      history: {
        serializedName: "history",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ThreatAlertHistoryItem"
            }
          }
        }
      },
      actions: {
        serializedName: "actions",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "None",
                "Dismiss",
                "SaveForLater",
                "TakeAction",
                "SeeDetails"
              ]
            }
          }
        }
      }
    }
  }
};

export const UnauthNotificationSettingPayload: coreHttp.CompositeMapper = {
  serializedName: "UnauthNotificationSettingPayload",
  type: {
    name: "Composite",
    className: "UnauthNotificationSettingPayload",
    modelProperties: {
      isEnabled: {
        required: true,
        serializedName: "isEnabled",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const UnauthOneTimeCyberAgentScanRequest: coreHttp.CompositeMapper = {
  serializedName: "UnauthOneTimeCyberAgentScanRequest",
  type: {
    name: "Composite",
    className: "UnauthOneTimeCyberAgentScanRequest",
    modelProperties: {
      emailAddress: {
        required: true,
        serializedName: "emailAddress",
        type: {
          name: "String"
        }
      },
      sessionId: {
        serializedName: "sessionId",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const UnauthOneTimeCyberAgentScanStatusData: coreHttp.CompositeMapper = {
  serializedName: "UnauthOneTimeCyberAgentScanStatusData",
  type: {
    name: "Composite",
    className: "UnauthOneTimeCyberAgentScanStatusData",
    modelProperties: {
      isRegistrationInGeoAvailable: {
        serializedName: "isRegistrationInGeoAvailable",
        type: {
          name: "Boolean"
        }
      },
      isRegistrationAvailable: {
        serializedName: "isRegistrationAvailable",
        type: {
          name: "Boolean"
        }
      },
      isEmailVerified: {
        serializedName: "isEmailVerified",
        type: {
          name: "Boolean"
        }
      },
      emailVerifiedDateTime: {
        serializedName: "emailVerifiedDateTime",
        type: {
          name: "DateTime"
        }
      },
      emailVerificationExpiredDateTime: {
        serializedName: "emailVerificationExpiredDateTime",
        type: {
          name: "DateTime"
        }
      },
      retrievalDateTime: {
        serializedName: "retrievalDateTime",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const UnauthOneTimeCyberAgentScanStatusRequest: coreHttp.CompositeMapper = {
  serializedName: "UnauthOneTimeCyberAgentScanStatusRequest",
  type: {
    name: "Composite",
    className: "UnauthOneTimeCyberAgentScanStatusRequest",
    modelProperties: {
      emailAddress: {
        required: true,
        serializedName: "emailAddress",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const UnauthOneTimeCyberAgentScanVerifyCodeResponse: coreHttp.CompositeMapper = {
  serializedName: "UnauthOneTimeCyberAgentScanVerifyCodeResponse",
  type: {
    name: "Composite",
    className: "UnauthOneTimeCyberAgentScanVerifyCodeResponse",
    modelProperties: {
      sessionId: {
        serializedName: "sessionId",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const UnsafeUrlAlertHistoryItem: coreHttp.CompositeMapper = {
  serializedName: "UnsafeUrlAlertHistoryItem",
  type: {
    name: "Composite",
    className: "UnsafeUrlAlertHistoryItem",
    modelProperties: {
      status: {
        serializedName: "status",
        type: {
          name: "Enum",
          allowedValues: [
            "None",
            "Blocked",
            "Bypassed"
          ]
        }
      },
      statusDescription: {
        serializedName: "statusDescription",
        type: {
          name: "String"
        }
      },
      eventDateTime: {
        serializedName: "eventDateTime",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const UnsafeUrlDetails: coreHttp.CompositeMapper = {
  serializedName: "UnsafeUrlDetails",
  type: {
    name: "Composite",
    className: "UnsafeUrlDetails",
    modelProperties: {
      alertId: {
        serializedName: "alertId",
        type: {
          name: "String"
        }
      },
      url: {
        serializedName: "url",
        type: {
          name: "String"
        }
      },
      deviceName: {
        serializedName: "deviceName",
        type: {
          name: "String"
        }
      },
      devicePlatform: {
        serializedName: "devicePlatform",
        type: {
          name: "Enum",
          allowedValues: [
            "Windows",
            "Android",
            "iOS",
            "macOS",
            "Unknown"
          ]
        }
      },
      category: {
        serializedName: "category",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "Phishing",
            "Malware",
            "Exploit",
            "Malvertising",
            "Untrusted",
            "Malicious",
            "TechScam",
            "CustomPolicy"
          ]
        }
      },
      alertCategory: {
        serializedName: "alertCategory",
        type: {
          name: "Enum",
          allowedValues: [
            "Info",
            "Threat"
          ]
        }
      },
      history: {
        serializedName: "history",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "UnsafeUrlAlertHistoryItem"
            }
          }
        }
      },
      actions: {
        serializedName: "actions",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "None",
                "Dismiss",
                "SaveForLater",
                "TakeAction",
                "SeeDetails"
              ]
            }
          }
        }
      }
    }
  }
};

export const UnsafeUrlParameters: coreHttp.CompositeMapper = {
  serializedName: "UnsafeUrlParameters",
  type: {
    name: "Composite",
    className: "UnsafeUrlParameters",
    modelProperties: {
      url: {
        required: true,
        serializedName: "url",
        type: {
          name: "String"
        }
      },
      detectionDateTime: {
        required: true,
        serializedName: "detectionDateTime",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const UpdateBankAccountRequest: coreHttp.CompositeMapper = {
  serializedName: "UpdateBankAccountRequest",
  type: {
    name: "Composite",
    className: "UpdateBankAccountRequest",
    modelProperties: {
      accountNumber: {
        required: true,
        serializedName: "accountNumber",
        type: {
          name: "String"
        }
      },
      bankRouting: {
        serializedName: "bankRouting",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const UpdateAccountDetailsRequest: coreHttp.CompositeMapper = {
  serializedName: "UpdateAccountDetailsRequest",
  type: {
    name: "Composite",
    className: "UpdateAccountDetailsRequest",
    modelProperties: {
      bankAccounts: {
        serializedName: "bankAccounts",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "UpdateBankAccountRequest"
            }
          }
        }
      },
      creditCardNumbers: {
        serializedName: "creditCardNumbers",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      debitCardNumbers: {
        serializedName: "debitCardNumbers",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      }
    }
  }
};

export const UpdateAlert: coreHttp.CompositeMapper = {
  serializedName: "UpdateAlert",
  type: {
    name: "Composite",
    className: "UpdateAlert",
    modelProperties: {
      isRead: {
        serializedName: "isRead",
        type: {
          name: "Boolean"
        }
      },
      isDismissed: {
        serializedName: "isDismissed",
        type: {
          name: "Boolean"
        }
      },
      isDismissedModifiedDateTime: {
        serializedName: "isDismissedModifiedDateTime",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const UpdateDatafieldBatchRequest: coreHttp.CompositeMapper = {
  serializedName: "UpdateDatafieldBatchRequest",
  type: {
    name: "Composite",
    className: "UpdateDatafieldBatchRequest",
    modelProperties: {
      entityIds: {
        required: true,
        serializedName: "entityIds",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      state: {
        serializedName: "state",
        type: {
          name: "Enum",
          allowedValues: [
            "Remediated",
            "FalsePositive",
            "NotRelevant",
            "New"
          ]
        }
      }
    }
  }
};

export const UpdateDriverLicenseRequest: coreHttp.CompositeMapper = {
  serializedName: "UpdateDriverLicenseRequest",
  type: {
    name: "Composite",
    className: "UpdateDriverLicenseRequest",
    modelProperties: {
      state: {
        serializedName: "state",
        type: {
          name: "String"
        }
      },
      number: {
        serializedName: "number",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const UpdateSubscriberCyberDataRequest: coreHttp.CompositeMapper = {
  serializedName: "UpdateSubscriberCyberDataRequest",
  type: {
    name: "Composite",
    className: "UpdateSubscriberCyberDataRequest",
    modelProperties: {
      ibans: {
        serializedName: "ibans",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      otherCards: {
        serializedName: "otherCards",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      passportDetails: {
        serializedName: "passportDetails",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "PassportRequest"
            }
          }
        }
      },
      nationalIdDetails: {
        serializedName: "nationalIdDetails",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "NationalIdRequest"
            }
          }
        }
      },
      driverLicense: {
        serializedName: "driverLicense",
        type: {
          name: "Composite",
          className: "UpdateDriverLicenseRequest"
        }
      },
      unverifiedPhones: {
        serializedName: "unverifiedPhones",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "UnverifiedPhoneRequest"
            }
          }
        }
      },
      isEncrypted: {
        serializedName: "isEncrypted",
        type: {
          name: "Boolean"
        }
      },
      telephoneNumbers: {
        serializedName: "telephoneNumbers",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      emailAddresses: {
        serializedName: "emailAddresses",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      medicalIDs: {
        serializedName: "medicalIDs",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      accountDetails: {
        serializedName: "accountDetails",
        type: {
          name: "Composite",
          className: "UpdateAccountDetailsRequest"
        }
      }
    }
  }
};

export const UpdateSubscriberProfileApiResponse: coreHttp.CompositeMapper = {
  serializedName: "UpdateSubscriberProfileApiResponse",
  type: {
    name: "Composite",
    className: "UpdateSubscriberProfileApiResponse",
    modelProperties: {
      name: {
        serializedName: "name",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const UpdateSubscriberRequest: coreHttp.CompositeMapper = {
  serializedName: "UpdateSubscriberRequest",
  type: {
    name: "Composite",
    className: "UpdateSubscriberRequest",
    modelProperties: {
      futureActivationDate: {
        serializedName: "futureActivationDate",
        type: {
          name: "DateTime"
        }
      },
      cyberData: {
        serializedName: "cyberData",
        type: {
          name: "Composite",
          className: "UpdateSubscriberCyberDataRequest"
        }
      },
      e2ESubscriberKey: {
        serializedName: "e2ESubscriberKey",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const UpdateTrustedNetworkRequest: coreHttp.CompositeMapper = {
  serializedName: "UpdateTrustedNetworkRequest",
  type: {
    name: "Composite",
    className: "UpdateTrustedNetworkRequest",
    modelProperties: {
      verdict: {
        required: true,
        serializedName: "verdict",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const UserAgeDetails: coreHttp.CompositeMapper = {
  serializedName: "UserAgeDetails",
  type: {
    name: "Composite",
    className: "UserAgeDetails",
    modelProperties: {
      dateOfBirth: {
        serializedName: "dateOfBirth",
        type: {
          name: "String"
        }
      },
      ageGroup: {
        serializedName: "ageGroup",
        type: {
          name: "Enum",
          allowedValues: [
            "Undefined",
            "MinorWithoutParentalConsent",
            "MinorWithParentalConsent",
            "Adult",
            "NotAdult",
            "MinorNoParentalConsentRequired"
          ]
        }
      }
    }
  }
};

export const UserProfileIdentity: coreHttp.CompositeMapper = {
  serializedName: "UserProfileIdentity",
  type: {
    name: "Composite",
    className: "UserProfileIdentity",
    modelProperties: {
      release: {
        serializedName: "release",
        type: {
          name: "Enum",
          allowedValues: [
            "SelfHost",
            "PrivatePreview",
            "PublicPreview",
            "GA"
          ]
        }
      },
      csid: {
        serializedName: "csid",
        type: {
          name: "Uuid"
        }
      },
      isAndroidBetaTrackUser: {
        serializedName: "isAndroidBetaTrackUser",
        type: {
          name: "Boolean"
        }
      },
      isWindowsBetaTrackUser: {
        serializedName: "isWindowsBetaTrackUser",
        type: {
          name: "Boolean"
        }
      },
      isMacOSBetaTrackUser: {
        serializedName: "isMacOSBetaTrackUser",
        type: {
          name: "Boolean"
        }
      },
      isIOSBetaTrackUser: {
        serializedName: "isIOSBetaTrackUser",
        type: {
          name: "Boolean"
        }
      },
      isClarityNoticeDismissed: {
        serializedName: "isClarityNoticeDismissed",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const UserProfile: coreHttp.CompositeMapper = {
  serializedName: "UserProfile",
  type: {
    name: "Composite",
    className: "UserProfile",
    modelProperties: {
      displayName: {
        serializedName: "displayName",
        type: {
          name: "String"
        }
      },
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      email: {
        serializedName: "email",
        type: {
          name: "String"
        }
      },
      lastName: {
        serializedName: "lastName",
        type: {
          name: "String"
        }
      },
      dateOfBirth: {
        serializedName: "dateOfBirth",
        type: {
          name: "Composite",
          className: "DateModel"
        }
      },
      givenName: {
        serializedName: "givenName",
        type: {
          name: "String"
        }
      },
      userId: {
        serializedName: "userId",
        type: {
          name: "String"
        }
      },
      countryOrRegionCode: {
        serializedName: "countryOrRegionCode",
        type: {
          name: "String"
        }
      },
      lastModifiedDateTime: {
        serializedName: "lastModifiedDateTime",
        type: {
          name: "DateTime"
        }
      },
      ageGroup: {
        serializedName: "ageGroup",
        type: {
          name: "Enum",
          allowedValues: [
            "Undefined",
            "MinorWithoutParentalConsent",
            "MinorWithParentalConsent",
            "Adult",
            "NotAdult",
            "MinorNoParentalConsentRequired"
          ]
        }
      },
      targetedGeoFencingData: {
        serializedName: "targetedGeoFencingData",
        type: {
          name: "Composite",
          className: "TargetedGeoFencingData"
        }
      },
      subscriberOnboardingStatus: {
        serializedName: "subscriberOnboardingStatus",
        type: {
          name: "Enum",
          allowedValues: [
            "NotStarted",
            "Completed"
          ]
        }
      },
      creditMonitoringOnboardingStatus: {
        serializedName: "creditMonitoringOnboardingStatus",
        type: {
          name: "Enum",
          allowedValues: [
            "NotStarted",
            "SSNFailed",
            "SSNRegistered",
            "Completed"
          ]
        }
      },
      identity: {
        serializedName: "identity",
        type: {
          name: "Composite",
          className: "UserProfileIdentity"
        }
      },
      isDogFoodUser: {
        serializedName: "isDogFoodUser",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const UserProfilePatchRequest: coreHttp.CompositeMapper = {
  serializedName: "UserProfilePatchRequest",
  type: {
    name: "Composite",
    className: "UserProfilePatchRequest",
    modelProperties: {
      isClarityNoticeDismissed: {
        serializedName: "isClarityNoticeDismissed",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const UserProfilePhotoMetadata: coreHttp.CompositeMapper = {
  serializedName: "UserProfilePhotoMetadata",
  type: {
    name: "Composite",
    className: "UserProfilePhotoMetadata",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      height: {
        serializedName: "height",
        type: {
          name: "String"
        }
      },
      width: {
        serializedName: "width",
        type: {
          name: "String"
        }
      },
      mediaContentType: {
        serializedName: "mediaContentType",
        type: {
          name: "String"
        }
      },
      mediaEtag: {
        serializedName: "mediaEtag",
        type: {
          name: "String"
        }
      },
      supportedSizesDescription: {
        readOnly: true,
        serializedName: "supportedSizesDescription",
        type: {
          name: "String"
        }
      }
    }
  }
};
